import { AfterViewInit, Component, ElementRef, EventEmitter, OnDestroy, OnInit, Output, QueryList, TemplateRef, ViewChild ,ViewContainerRef} from '@angular/core';
import * as d3 from 'node_modules/d3'
import { CdkOverlyayService } from 'src/app/shared/custom-overlay/cdk-overlyay.service';
import { TemplateDropdownComponent } from 'src/app/shared/custom-overlay/template-dropdown/template-dropdown.component';
// import { UserLoginService } from '../user-login.service';
import { distinctUntilChanged, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { AlertsvarService } from '../alertsvar.service';
import { AlertsService } from '../alerts-custom.service';
import * as echarts from "echarts";
import { TimeZoneService } from 'src/app/services/time-zone.service';
import { Overlay,OverlayRef } from '@angular/cdk/overlay';
import { TemplatePortal } from '@angular/cdk/portal';
import { cdkOverlayRef } from 'src/app/shared/custom-overlay/cdk-overlay-ref';
import * as moment from 'moment';
import { AdvanceFilterComponent } from '../template/advance-filter/advance-filter.component';
import { ToastService } from 'src/app/shared/custom-overlay/toast/toast.service';
import { ToastType } from 'src/app/shared/shared.enums';
import { SharedService } from 'src/app/services/shared.service';



@Component({
  selector: 'app-relation-chart',
  templateUrl: './relation-chart.component.html',
  styleUrls: ['./relation-chart.component.scss']
})
export class RelationChartComponent implements OnInit, AfterViewInit, OnDestroy {
  relationist
  @Output() NodeSelected: EventEmitter<any> = new EventEmitter();

  @ViewChild('relationList',{ static: false }) relationList: TemplateRef<any>;
  @ViewChild('instantfilter',{ static: false }) instantfilter: TemplateRef<any>;
  @ViewChild('contextList') contextList: ElementRef;
  @ViewChild('moreOptionOrigin') moreOptionOrigin: ElementRef;
  @ViewChild('moreOptionRef') moreOptionRef: ElementRef;
  @ViewChild('visualizeOptionOrigin') visualizeOptionOrigin: ElementRef;
  @ViewChild('visualizeRef') visualizeRefTemp: ElementRef;
  @ViewChild('legendOptionOrigin') legendOrigin: ElementRef;
  @ViewChild('legendRef') legendRefTemp: ElementRef;

  data = {}
  instantFilterOption;
  relationListMenu:cdkOverlayRef;
  instantfilterMenu:cdkOverlayRef;
  contextListMenu;
  moreOptionState: boolean = false;
  dialogRef;
  templateRef;
  legendRef;
  visualizeRef;
  legends = [
    { color: ['#c59393'], label: 'Selected entity',value:'',showCnt:false},
    { color: ['#888'], label: 'Has alerts',value:'has_alerts',showCnt:true },
    { color: ['rgb(211, 211, 211)'], label: 'Has no alerts',value:'has_no_alerts',showCnt:true },
    { color: ['#13abec', '#136aec'], label: 'Selected relations',value:'',showCnt:false },
    // { color: ['#f0c400'], label: 'Highlighted' },
    // { color: ['#136aec'], label: 'Selected relations' },
    { color: ['#f0c400', '#4b0'], label: 'Highlighted relations' ,value:'',showCnt:false}
  ];
  chartOption = {
    tooltip: {
      trigger: 'item'
    },
    xAxis: {
      type: 'category',
      data: []
    },
    yAxis: {
      type: 'value'
    },
    series: [
      {
        data: [],
        type: 'bar'
      }
    ]
  };

  myChart
  overLayRef: cdkOverlayRef;
  instantFilterParentId: number=0;
  instantFilterChildId: number=0;
  constructor(
    private viewContainerRef: ViewContainerRef,
    private overlay: Overlay,
    private cdkoverlayDialog: CdkOverlyayService,
    public alertvarService: AlertsvarService,
    public alertService: AlertsService,
    private timezoneservice: TimeZoneService,
    private toastservice: ToastService,
    private sharedService:SharedService
  ) { }
  $destroy: Subject<boolean> = new Subject();
  isAction: boolean = this.alertvarService.alertactionmanagement.procressProgress();
  selectedrelationMenuKey:string=''

  async ngAfterViewInit(){
    // console.log(this.alertvarService.advanced_filter_values)
    // console.log(this.alertvarService.alertsheetmeta.filterOptions.advanceFilter)
    this.alertvarService.nodeSelected = false

    this.openOverlay_moreoptions_click(this.moreOptionRef, this.moreOptionOrigin)

    // setTimeout(() => {
    //   this.openOverlay_templates(this.legendRefTemp, this.legendOrigin)

    // }, 500);
    this.alertService.provided3chartevents.isProgress$.pipe(takeUntil(this.$destroy)).subscribe((progress: boolean) => {
      this.alertvarService.alertactionmanagement.updateAction.next(['chartprogress', progress]);
    })
    this.alertService.updated3chartevents.isProgress$.pipe(takeUntil(this.$destroy)).subscribe((progress: boolean) => {
      this.alertvarService.alertactionmanagement.updateAction.next(['chartprogress', progress]);
    })

    this.alertvarService.alertactionmanagement.actionManagement
      .pipe(distinctUntilChanged()).pipe(takeUntil(this.$destroy)).subscribe((progress: boolean) => {
        this.isAction = progress;
      })

    this.initiateChart()
    this.alertvarService.handleprovided3chartdataerror.resetError();
    //empty bubbles in all the nodes
    var tempStructure = this.updateKeyInNestedObjects(this.alertvarService.chartData, "bubbles", [])
    tempStructure = this.updateKeyInNestedObjects(tempStructure, "bubble_values", [])
    tempStructure = this.updateKeyInNestedObjects(tempStructure, "predecessorIds", [])
    tempStructure = this.updateKeyInNestedObjects(tempStructure, "target_entity", [])

    var req_obj = {
      "alert_id": this.alertvarService.alertscollapsedata.selectedalert.alertId,
      "hosts":this.alertvarService.alertscollapsedata.selectedalert.hosts,
      "platform" :this.alertvarService.alertscollapsedata.selectedalert.platform,
      "season_time": [this.timezoneservice.toUtcTimeZonefromUser(this.alertvarService.advanced_filter_values.start_time).format("YYYY-MM-DD HH:mm:ss"), this.timezoneservice.toUtcTimeZonefromUser(this.alertvarService.advanced_filter_values.end_time).format("YYYY-MM-DD HH:mm:ss")],
      "episode_duration": this.alertvarService.advanced_filter_values.time_interval.value,
      "threshold": this.alertvarService.bubbleThreshold,
      "parent_node": "",
      "template": tempStructure,
      "relation": "isInEpisode",
      "updateNode": tempStructure.id,
      "isRoot":1,
      "ref_no":this.alertvarService.chart_ref_no,
      "timeZone":this.sharedService.timeZone
    }
    this.alertvarService.rootNodeEpisodesCount = 0
    this.alertService.updated3chartevents.storeData = {"template":{...this.alertvarService.chartData},"ref_no":this.alertvarService.chart_ref_no}
    this.alertvarService.template_structure = tempStructure;
    this.alertService.updated3chartevents.postrequest(req_obj)
      .pipe(takeUntil(this.$destroy))
      .subscribe((data: any) => {
        this.alertvarService.chart_ref_no = data.ref_no
        this.alertvarService.rootNodeEpisodesCount = data.template.count
        let target_entity_fields = data.template.target_entity?data.template.target_entity:[]
        this.calculateAlertLowestHighetsInsightInfo(target_entity_fields,data.template.bubbles)
        

        
        this.updateObjectById(this.alertvarService.chartData, data.template.id, data.template)
        // setTimeout(() => {
          this.updateChart()
// console.log("Node Clicked 1")
          this.nodeClicked({ "data": this.alertvarService.chartData }, 1)
          this.alertvarService.getAlertCountPerTimePeriod(data.template)
        // }, 500);
      }, (error) => {
        this.alertvarService.handleprovided3chartdataerror.seterror(true, error.error?.errmsg)
      })




    this.alertvarService.advancedFilterChange.subscribe((data) => {
      this.alertvarService.rootNodeEpisodesCount = 0
      this.alertvarService.handleprovided3chartdataerror.resetError();
      //empty all bubbles
      var parentNode = this.getParentById(this.alertvarService.chartData,this.alertvarService.nodeinfo.id)
      var tempStructure = this.updateKeyInNestedObjects(this.alertvarService.chartData, "bubbles", [])
      tempStructure = this.updateKeyInNestedObjects(tempStructure, "bubble_values", [])
      tempStructure = this.updateKeyInNestedObjects(tempStructure, "filters", [])
      tempStructure = this.updateKeyInNestedObjects(tempStructure, "predecessorIds", [])
      tempStructure = this.updateKeyInNestedObjects(tempStructure, "target_entity", [])
      var req_obj = {
        "alert_id": this.alertvarService.alertscollapsedata.selectedalert.alertId,
        "hosts":this.alertvarService.alertscollapsedata.selectedalert.hosts,
        "platform" :this.alertvarService.alertscollapsedata.selectedalert.platform,
        "season_time": [this.timezoneservice.toUtcTimeZonefromUser(this.alertvarService.advanced_filter_values.start_time).format("YYYY-MM-DD HH:mm:ss"), this.timezoneservice.toUtcTimeZonefromUser(this.alertvarService.advanced_filter_values.end_time).format("YYYY-MM-DD HH:mm:ss")],
        "episode_duration": this.alertvarService.advanced_filter_values.time_interval.value,
        "threshold": this.alertvarService.bubbleThreshold,
        "parent_node": parentNode?parentNode.node:"",
        "template": tempStructure,
        "relation": "emitted",
        "updateNode": tempStructure.id,
        "isRoot":1,
        "ref_no":this.alertvarService.chart_ref_no,
        "timeZone":this.sharedService.timeZone
      }

      this.alertvarService.template_structure = tempStructure;
      this.alertService.updated3chartevents.postrequest(req_obj)
        .pipe(takeUntil(this.$destroy))
        .subscribe((data: any) => {
          this.alertvarService.chart_ref_no = data.ref_no
          this.alertvarService.rootNodeEpisodesCount = data.template.count
          let target_entity_fields = data.template.target_entity?data.template.target_entity:[]
          this.calculateAlertLowestHighetsInsightInfo(target_entity_fields,data.template.bubbles)
          // let rootNodeEntityFields = []
          // data.template.target_entity.forEach((item:any)=>{
          //   rootNodeEntityFields.push(item['label'])
          // })
          // this.alertvarService.rootNodeEntityFields = rootNodeEntityFields
          this.updateObjectById(this.alertvarService.chartData, data.template.id, data.template)
          setTimeout(() => {
            this.updateChart()
            this.NodeSelected.emit([0, this.getObjectById(this.alertvarService.chartData, this.alertvarService.lastClickedNode.id)]);
            this.alertvarService.getAlertCountPerTimePeriod(data.template)
          }, 500);
        }, (error) => {
          this.alertvarService.handleprovided3chartdataerror.seterror(true, error.error?.errmsg)
        })
    })

    this.alertvarService.nodeFilter.subscribe((data) => {
      this.alertvarService.nodeinfo.filters = data
      this.alertvarService.handleprovided3chartdataerror.resetError();
      // var parentNode = this.getBranchWithAncestors(this.alertvarService.chartData, this.alertvarService.nodeinfo.id)
      this.updateObjectById(this.alertvarService.chartData,this.alertvarService.nodeinfo.id,this.alertvarService.nodeinfo)
      var parentNode = this.getParentById(this.alertvarService.chartData,this.alertvarService.nodeinfo.id)
      var formRoot = this.getBranchWithAncestors(this.alertvarService.chartData, this.alertvarService.nodeinfo.id)

      var tempStructure = this.updateKeyInNestedObjects(formRoot, "bubbles", [])
      tempStructure = this.updateKeyInNestedObjects(tempStructure, "bubble_values", [])
      tempStructure = this.updateKeyInNestedObjects(tempStructure, "predecessorIds", [])
      tempStructure = this.updateKeyInNestedObjects(tempStructure, "target_entity", [])
      //piioi

      var req_obj = {
        "alert_id": this.alertvarService.alertscollapsedata.selectedalert.alertId,
        "hosts":this.alertvarService.alertscollapsedata.selectedalert.hosts,
        "platform" :this.alertvarService.alertscollapsedata.selectedalert.platform,
        "season_time": [this.timezoneservice.toUtcTimeZonefromUser(this.alertvarService.advanced_filter_values.start_time).format("YYYY-MM-DD HH:mm:ss"), this.timezoneservice.toUtcTimeZonefromUser(this.alertvarService.advanced_filter_values.end_time).format("YYYY-MM-DD HH:mm:ss")],
        "episode_duration": this.alertvarService.advanced_filter_values.time_interval.value,
        "threshold": this.alertvarService.bubbleThreshold,
        "parent_node": parentNode ? parentNode.node : "",
        "template": tempStructure,
        "relation": this.alertvarService.nodeinfo.relation,
        "updateNode": this.alertvarService.nodeinfo.id,
        "isRoot":this.alertvarService.nodeinfo.id == 1?1:0,
        "ref_no":this.alertvarService.chart_ref_no,
        "timeZone":this.sharedService.timeZone
      }
      this.alertvarService.template_structure = tempStructure;
      // this.alertvarService.updatingD3=true
      this.alertService.updated3chartevents.postrequest(req_obj)
        .pipe(takeUntil(this.$destroy))
        .subscribe((data: any) => {
          this.alertvarService.chart_ref_no = data.ref_no
          this.updateObjectById(this.alertvarService.chartData, data.template.id, data.template)
          setTimeout(() => {
            this.updateChart()
            this.NodeSelected.emit([0, this.getObjectById(this.alertvarService.chartData, this.alertvarService.lastClickedNode.id)]);
            this.alertvarService.nodeSelected = true
            // this.alertvarService.updatingD3=false
          }, 500);
        }, (error) => {
          // this.alertvarService.updatingD3=false
          this.alertvarService.handleprovided3chartdataerror.seterror(true, error.error?.errmsg)
        })
    })
    
    this.alertvarService.nodeInstantFilter.subscribe((data)=>{
      this.alertvarService.handleprovided3chartdataerror.resetError();
      this.updateObjectById(this.alertvarService.chartData,this.alertvarService.nodeinfo.id,this.alertvarService.nodeinfo)
      var parentNode = this.getParentById(this.alertvarService.chartData,this.alertvarService.nodeinfo.id)
      var formRoot = this.getBranchWithAncestors(this.alertvarService.chartData, this.alertvarService.nodeinfo.id)
      
      var tempStructure = this.updateKeyInNestedObjects(formRoot, "bubbles", [])
      tempStructure = this.updateKeyInNestedObjects(tempStructure, "bubble_values", [])
      tempStructure = this.updateKeyInNestedObjects(tempStructure, "predecessorIds", [])
      tempStructure = this.updateKeyInNestedObjects(tempStructure, "target_entity", [])

      var req_obj = {
        "alert_id": this.alertvarService.alertscollapsedata.selectedalert.alertId,
        "hosts":this.alertvarService.alertscollapsedata.selectedalert.hosts,
        "platform" :this.alertvarService.alertscollapsedata.selectedalert.platform,
        "season_time": [this.timezoneservice.toUtcTimeZonefromUser(this.alertvarService.advanced_filter_values.start_time).format("YYYY-MM-DD HH:mm:ss"), this.timezoneservice.toUtcTimeZonefromUser(this.alertvarService.advanced_filter_values.end_time).format("YYYY-MM-DD HH:mm:ss")],
        "episode_duration": this.alertvarService.advanced_filter_values.time_interval.value,
        "threshold": this.alertvarService.bubbleThreshold,
        "parent_node": parentNode ? parentNode.node : "",
        "template": tempStructure,
        "relation": this.alertvarService.nodeinfo.relation,
        "updateNode": this.alertvarService.nodeinfo.id,
        "isRoot":this.alertvarService.nodeinfo.id == 1? 1:0,
        "ref_no":this.alertvarService.chart_ref_no,
        "timeZone":this.sharedService.timeZone
      }
      this.alertvarService.template_structure = tempStructure;
      this.alertService.updated3chartevents.postrequest(req_obj)
        .pipe(takeUntil(this.$destroy))
        .subscribe((data: any) => {
          this.alertvarService.chart_ref_no = data.ref_no
          this.updateObjectById(this.alertvarService.chartData, data.template.id, data.template)
          setTimeout(() => {
            this.updateChart()
            this.NodeSelected.emit([0, this.getObjectById(this.alertvarService.chartData, this.alertvarService.lastClickedNode.id)]);
            this.alertvarService.nodeSelected = true
          }, 500);
        }, (error) => {
          this.alertvarService.handleprovided3chartdataerror.seterror(true, error.error?.errmsg)
        })
    })
    this.alertvarService.centerAlign()
  }
  ngOnInit(): void {
  }
  ngOnDestroy(): void {
    this.alertvarService.handleprovided3chartdataerror.resetError();
    this.$destroy.next()
  }
  initiateChart() {
    var svg = d3.select(".connector")
    const width = parseInt(d3.style(svg.node(), "width").replace('px', ''));
    const height = parseInt(d3.style(svg.node(), "height").replace('px', ''));
    svg.select("#exploration-zoom-pan-canvas").call(d3.drag()
      .on('start', dragStart)
      .on('drag', dragging)
      .on('end', dragEnd))
      .call(d3.zoom()
        .extent([[0, 0], [width, height]])
        .scaleExtent([0.5, 2])
        .on("zoom", zoomed))
      .on("dblclick.zoom", null);


    let initialX, initialY, initialK;
    let offsetX, offsetY;
    function zoomed({ transform }) {
      const currentTransform = d3.style(d3.select("#exploration-graph").node(), "transform").replace(/matrix\(|\)/g, '').split(",")
      svg.select('#exploration-graph').attr("transform", "translate(" + (parseFloat(currentTransform[currentTransform.length - 2])) + "," + (parseFloat(currentTransform[currentTransform.length - 1])) + ") scale(" + transform.k + "," + transform.k + ")");
      // svg.select('#exploration-graph').attr("transform", transform);
    }
    function dragStart(event, d) {
      // svg.select("#exploration-graph").attr("stroke", "grey");
      const currentTransform = d3.style(d3.select("#exploration-graph").node(), "transform").replace(/matrix\(|\)/g, '').split(",")
      initialX = parseFloat(currentTransform[currentTransform.length - 2]);
      offsetX = event.x;
      initialY = parseFloat(currentTransform[currentTransform.length - 1]);
      offsetY = event.y;
      initialK = parseFloat(currentTransform[0]);
    }
    function dragging(event, d) {
      var newCoordinate = "translate(" + (initialX + (event.x - offsetX)) + "," + (initialY + (event.y - offsetY)) + ") scale(" + initialK + "," + initialK + ")"
      d3.select("#exploration-graph").attr("transform", newCoordinate);
    }
    function dragEnd(event, d) {
      // d3.select("#exploration-graph").attr("stroke", null);
    }
  }
  updateChart() {
//console.log('==========updateChart=====fn====');
    
    var root = d3.hierarchy(this.alertvarService.chartData)
    var treeLayout = d3.tree().size([0, 0]).nodeSize([150, 300]);
    treeLayout(root);
    let nodeRadius = 50;
    var svg = d3.select(".connector");
    let self = this
    var bubbleThreshold = self.alertvarService.bubbleThreshold;
    var episode = self.alertvarService.advanced_filter_values.time_interval.value


// console.log("Node Clicked 2")
    let nodes = svg.select('g.nodes')
      .selectAll('.exploration-node')
      .data(root.descendants(), d => d.data.id)
      .join(
        enter => enter.append("g")
          .attr('transform', d => `translate(${d.y},${d.x})`)
          .attr("data-id", d => d.data.id)
          .attr("id", d => d.data.id)
          .classed("exploration-node", true)
          .on("mouseover", function (event, d) {
            d3.select(this).select("#cat_" + d.data.id).style("visibility", "visible")
            d3.select(this).select('#grp_cir1_rect').select(".cir_anchor").style("visibility", "visible")
            d3.select(this).select('#grp_cir1_rect').select("text").style("visibility", "visible")
            // .attr("transform", "translate(" + (nodeRadius + (nodeRadius * 0.1)).toString() + ",0)")
          })
          .on("mouseout", function (event, d) {
            d3.select(this).select("#cat_" + d.data.id).style("visibility", "hidden")
            d3.select(this).select('#grp_cir1_rect').select(".cir_anchor").style("visibility", "hidden")
            d3.select(this).select('#grp_cir1_rect').select("text").style("visibility", "hidden")
            // d3.select(this).select('#grp_cir1_rect')
            //   .attr("transform", "translate(15,0)")
          })

          // Apply styles and properties to new nodes
          .call(enter => enter.append("g").
            attr("id", "grp_cir1_rect")
            .attr("transform", "translate(" + (nodeRadius + (nodeRadius * 0.1)) + ",0)")

          )
          .call(enter => enter.select('#grp_cir1_rect')
            .append("rect")
            .attr("id", "grp_rect")
            .attr("x", "0")
            .attr("y", -nodeRadius)
            .attr("width", nodeRadius * 1)
            .attr("height", nodeRadius * 2)
            .style("visibility", "hidden")
            .style("fill", "none")
          )
          .call(enter => enter.select('#grp_cir1_rect')
            .append("circle")
            .attr("r", "15")
            .attr("x", "15")
            .attr("y", -nodeRadius)
            .style("visibility", "hidden")
            .classed("cir_anchor", true)
            .classed("circle", true)
            .on("click", (event, d) => { return this.openRelations(d) })
          )
          .call(enter => enter.select('#grp_cir1_rect')
            .append("text")
            .text("+")
            .attr("id", d => `cir_anchor_${d.data.id}`)
            .classed("text", true)
            .style("cursor", "pointer")
            .style("font-size", "16px")
            .style("dominant-baseline", "middle")
            .style("visibility", "hidden")
            .attr("pointer-events", "none")
          )
          .call(enter => enter.append("circle")
            .classed('circle', true)
            .classed('inner-circle', true)
            .attr("id", d => `inner_cat_${d.data.id}`)
            // .attr('r', nodeRadius)
          )
          
          .call(enter => enter.append("circle")
            .classed('circle', true)
            .classed('outer-circle', true)
            .attr("id", d => `cat_${d.data.id}`)
            // .attr('r', nodeRadius + (nodeRadius*0.1))
            .style("visibility", "hidden")
            // .on("contextmenu", (event, d) => { return this.contextMenu(event, d) })
            
            .on("click", (event, d) => { return this.nodeClicked(d, 0) })

            // 
          )
          .call(enter => enter.append("text")
            .text(d => d.data.count + ' ' + d.data.node)
            .classed("label", true)
            .attr("x", 0)
            .attr("y", 0)
            .attr("text-anchor", "middle")
          )
          .call(enter => enter.append("text")
            // .text("(" + (Math.floor(Math.random() * (69690 - 1048) + 1048)) + ")")
            .text(d => "(" + d.data.total_alert_count + " Alerts)")
            // .text(d => "(" + getTotalCount(d) + ")")
            // .text(d => d.data.count)

            .classed("label-count", true)
            .attr("x", 0)
            .attr("y", 0)
            .attr("text-anchor", "middle")
          )

          .call(enter => enter.append("text")
            .text(d => d.data.count)
            .classed("count", true)
            .attr("x", 0)
            .attr("y", 0)
            .attr("text-anchor", "middle")
            .attr("alignment-baseline", "middle")
          )
          .call(enter => enter.append("g")
            .classed('bubbles', true))
        ,
        update => update
          .transition().duration(100)
          .attr('transform', d => `translate(${d.y},${d.x})`)
        ,
        exit => exit
          .transition().duration(100)
          .style("opacity", 0)
          .remove()
      );
    nodes.each(function (node) {
      const packWidth = d3.select(this).node().getBBox().width;
      const packHeight = d3.select(this).node().getBBox().height;
      const packedRoot = d3.hierarchy({ children: node.data.bubbles.length > bubbleThreshold || !node.data.bubbles.length ? []:node.data.bubbles }).sort((a, b) => b.count - a.count);
      var pack = d3.pack().size([packWidth, packHeight]).radius(() => { return 5 }).padding(2);
      pack(packedRoot);
      // Select the .bubbles group (created in the enter phase) and bind data to circles
      
      const packGroup = d3.select(this).select(".bubbles").attr("transform", `translate(${-(packWidth / 2)}, ${-(packHeight / 2)})`);
      var nodeRadius = 0
      if (packedRoot.r + 5 < 25)
        nodeRadius = 25
      else
        nodeRadius = packedRoot.r + 5;
      d3.select(this).select("#grp_cir1_rect").select("#grp_rect").attr("y", -nodeRadius).attr("width", nodeRadius * 1).attr("height", nodeRadius * 2);
      d3.select(this).select('#grp_cir1_rect').attr("transform", "translate(" + (nodeRadius + (nodeRadius * 0.1)) + ",0)")
      d3.select(this).select("#inner_cat_" + node.data.id).attr("r", nodeRadius)
      d3.select(this).select("#cat_" + node.data.id).attr("r", nodeRadius + (nodeRadius * 0.1))
      d3.select(this).select(".count").style("visibility", "hidden")
      d3.select(this).select(".label").text(d => numberWithCommas(d.data.count) + ' ' + d.data.node).attr("y", nodeRadius + 20)
      d3.select(this).select(".label-count").attr("y", nodeRadius + 35).text(d => "(" + numberWithCommas(d.data.total_alert_count) + " Alerts)")

      
      packGroup.selectAll("circle")
      .data(packedRoot)
      .join(
        enter => enter.append("circle")
          .attr("r", 0)  // Start with radius 0 for smooth animation
          .attr("data-id", d => d.data.id)
          .on("mouseover", function (event,d) {
            if(node.data.node == 'Episodes'){
              let data_val = valueConverter(d.data.value,node.data.node)
              d3.select(".svg-tooltip").select(".value").html("")
              d3.select(".svg-tooltip").select(".value").append("span").classed("key-text",true).html("Start: ")
              d3.select(".svg-tooltip").select(".value").append("span").classed("date-text",true).html(data_val['ds1'])
              d3.select(".svg-tooltip").select(".value").append("span").classed("date-text",true).html(data_val['ds2']).style("font-weight", 600)

              d3.select(".svg-tooltip").select(".value2").html("")
              d3.select(".svg-tooltip").select(".value2").append("span").classed("time-text",true).html("End: ")
              d3.select(".svg-tooltip").select(".value2").append("span").classed("date-text",true).html(data_val['de1'])
              d3.select(".svg-tooltip").select(".value2").append("span").classed("time-text",true).html(data_val['de2']).style("font-weight", 600)
            }
            else{
              d3.select(".svg-tooltip").select(".value2").html("")
              d3.select(".svg-tooltip").select(".value")
              // .html(valueConverter(d.data.value));
              .html(d.data.value);
            }
            
            let value = countToPercent(d.data.count, node.data.total_alert_count)
            d3.select(".svg-tooltip").select(".count").select('.count-value').html(value.count)
            d3.select(".svg-tooltip").select(".percent").select('.percent-value').html(value.percent)
            d3.select(".svg-tooltip").style("opacity", 1)
            d3.select(".svg-tooltip").style("z-index", 1000)
            d3.select(this).classed("circle-hovered", true)
            highlightBubbles(node, this)
          })
          .on("mousemove",function(event,d){
            d3.select(".svg-tooltip")
              .style("left", (event.pageX + 30) + "px")
              .style("top", (event.pageY) + "px");
          })
          .on("mouseout", function (event,d) {
            d3.select(".svg-tooltip").style("opacity", 0)
            d3.select(".svg-tooltip").style("z-index", -1)
            d3.select(this).classed("circle-hovered", false)
            dehighlightBubbles(node, this)
          })
          .on("click", function (event,d) {
            highlightBubblesClicked(node, this)
            
            var element = document.getElementById(d.data.id)
            element?.scrollIntoView({
              behavior: "smooth",
              block: "nearest",
              inline:"start"
          })
          element?.classList.add("highlight_list")
          setTimeout(() => {
            element?.classList.remove("highlight_list");
        }, 1000);
          })
          .attr("cx", d => d.x)
          .attr("cy", d => d.y)
          // .attr("class", d => d.depth === 0 ? "parent-bubble" : "bubble")
          .attr("class", d => bubbleColor(d))
          // .attr("class", d => d.data.count == 0 && d.depth > 0 ? "empty-bubble" : "bubble")
          // .transition().duration(100)
          .attr("r", d => d.r)  // Animate the radius to its actual size
        ,
        update => update
          // .transition().duration(100)
          .attr("cx", d => d.x)
          .attr("cy", d => d.y)
          .attr("r", d => d.r)
          .attr("class", d => bubbleColor(d)),  // Animate position and radius changes
        exit => exit
          // .transition().duration(100)
          .attr("r", 0)  // Shrink radius to 0 on exit
          .remove()  // Remove after transition
      );
      // }
      // else {
      if (node.data.bubbles.length > bubbleThreshold || !node.data.bubbles.length) {

        var nodeRadius = 50;
        d3.select(this).select("#grp_cir1_rect").select("#grp_rect").attr("y", -nodeRadius).attr("width", nodeRadius * 1).attr("height", nodeRadius * 2);
        d3.select(this).select('#grp_cir1_rect').attr("transform", "translate(" + (nodeRadius + (nodeRadius * 0.1)) + ",0)")
        d3.select(this).select("#inner_cat_" + node.data.id).attr("r", nodeRadius)
        d3.select(this).select("#cat_" + node.data.id).attr("r", nodeRadius + (nodeRadius * 0.1))
        d3.select(this).select(".label").text(d => numberWithCommas(d.data.count) + ' ' + d.data.node).attr("y", nodeRadius + 20)
        d3.select(this).select(".count").style("visibility", "visible").text(d => numberWithCommas(d.data.count))
        

        d3.select(this).select(".label-count").attr("y", nodeRadius + 35).text(d => "(" + numberWithCommas(d.data.total_alert_count) + " Alerts)")
        d3.select(this).select(".inner-circle").attr("r", nodeRadius)
        d3.select(this).select(".outer-circle").attr("r", nodeRadius + (nodeRadius * 0.1))
      }
    });
    function numberWithCommas(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }
    var links = svg.select('g.links')
      .selectAll(".grp_path")
      .data(root.links(), d => d.source.data.id + "-" + d.target.data.id)
      .join(
        enter => enter.append("g")
          .classed("grp_path", true)
          .call(enter => enter.append("path")
            .attr("d", d => drawPath(d)))
          .call(enter => enter.append("text")
            .text(d => d.target.data.relation + " -> "+d.target.data.node)
            .classed("text", true)
            .attr("text-anchor", "middle")
            .attr("dominant-baseline", "middle")
            .attr("x", d => `${movePathLabel(d).x}`)
            .attr("y", d => `${movePathLabel(d).y}`)
            // .attr("transform", d => rotatePathText(d))
          )
        ,
        update => {
          update
            .select("path")
            .transition().duration(100)
            .attr("d", d => drawPath(d))
          // .call(update => 
          update
            .select("text")
            .transition().duration(100)
            .attr("x", d => `${movePathLabel(d).x}`)
            .attr("y", d => `${movePathLabel(d).y}`)
          // .attr("transform", d => rotatePathText(d))

          // )
        }
        ,
        exit => exit.remove()
      );
      // function valueConverter(value) {

      //   var d = moment.unix(parseInt(value)).tz('UTC').format("YYYY MMM DD HH:mm")
      //   var d_ebd = moment.unix(parseInt(value) + episode).tz('UTC').format("HH:mm")
      //   if (Number(value))
      //     return d + " - " + d_ebd;
      //   else
      //     return value
      // }

      function valueConverter(value,nodeData) {
        if (nodeData == 'Episodes'){
          var start_d = moment.unix(parseInt(value)).tz('UTC')
          var end_d = moment.unix(parseInt(value) + self.alertvarService.advanced_filter_values.time_interval.value*60).tz('UTC')
          // ds1 = .format("YYYY MMM DD HH:mm")
          // // var d_ebd = moment.unix(parseInt(value) + episode*60).tz('UTC').format("HH:mm")
          // var d_ebd = moment.unix(parseInt(value) + episode*60).tz('UTC').format("YYYY MMM DD HH:mm")

          return {
            ds1:start_d.format("YYYY MMM DD "),
            ds2:start_d.format("HH:mm"),
            de1:end_d.format("YYYY MMM DD "),
            de2:end_d.format("HH:mm"),
          };
        }
        // else{
        //   return value
        // }
      }

      function countToPercent(count, total) {
        var percent = ((count / total) * 100).toFixed(2) + "%"
        return { "count": count, "percent": percent }
      }
    function bubbleColor(d) {
      if (d.depth === 0) {
        return "parent-bubble"
      }
      else {
        if (d.data.count == 0) {
          return "empty-bubble"
        }
        else {
          return "bubble"
        }
      }
    }
    function rotatePathText(d) {
      // Calculate the angle of rotation based on source and target
      const dx = d.target.y - d.source.y;
      const dy = d.target.x - d.source.x;
      const angle = Math.atan2(dy, dx) * 180 / Math.PI;  // Convert to degrees

      // Rotate the text around its midpoint
      return `rotate(${angle}, ${(d.source.y + d.target.y) / 2}, ${(d.source.x + d.target.x) / 2})`;
    }
    // function movePathLabel(node) {

    //   const svg = d3.select("svg");
    //   var sourceNode = svg.select("#exploration-graph").select(".nodes").selectAll(".exploration-node").filter((data, i, nodes) => nodes[i].getAttribute("data-id") && nodes[i].getAttribute("data-id") == node.source.data.id);
    //   var targetNode = svg.select("#exploration-graph").select(".nodes").selectAll(".exploration-node").filter((data, i, nodes) => nodes[i].getAttribute("data-id") && nodes[i].getAttribute("data-id") == node.target.data.id);
    //   var sourceRadius = parseInt(sourceNode.select("#cat_" + node.source.data.id).node().getAttribute("r"));
    //   var targetRadius = parseInt(targetNode.select("#cat_" + node.target.data.id).node().getAttribute("r"));

    //   const sourceX = node.source.y, sourceY = node.source.x - (sourceRadius);
    //   const targetX = node.target.y, targetY = node.target.x - (targetRadius);



    //   var controlX = (sourceX + targetX) / 2 - 6;  // Midpoint for smooth curves
    //   var controlY = (sourceY + targetY) / 2;  // Midpoint for smooth curves

    //   if (sourceRadius > targetRadius) {
    //     controlY = controlY + (sourceRadius) - 9
    //   }
    //   else if (sourceRadius < targetRadius - 12) {
    //     controlY = controlY + (targetRadius) - 12
    //   }
    //   else {
    //     controlY = controlY + targetRadius
    //   }


    //   // controlY = controlY + (targetRadius - sourceRadius)
    //   return { x: controlX, y: controlY }
    // }
    function movePathLabel(d) {
      // const svg = d3.select("svg");
      const svg = d3.select(".connector");
      var sourceNode = svg.select("#exploration-graph").select(".nodes").selectAll(".exploration-node").filter((data, i, nodes) => nodes[i].getAttribute("data-id") && nodes[i].getAttribute("data-id") == d.source.data.id);
      var targetNode = svg.select("#exploration-graph").select(".nodes").selectAll(".exploration-node").filter((data, i, nodes) => nodes[i].getAttribute("data-id") && nodes[i].getAttribute("data-id") == d.target.data.id);

      var sourceRadius = parseInt(sourceNode.select("#cat_" + d.source.data.id).node().getAttribute("r"));
      var targetRadius = parseInt(targetNode.select("#cat_" + d.target.data.id).node().getAttribute("r"));
      const sourceX = d.source.y, sourceY = d.source.x - (sourceRadius);
      const targetX = d.target.y, targetY = d.target.x - (targetRadius);

      const controlX = (sourceX + targetX) / 2;  // Midpoint for smooth curves
      var controlY = (sourceY + targetY) / 2;  // Midpoint for smooth curves
      var narrowWidth = 5; // Narrower width in the middle
      if (sourceRadius > targetRadius) {
        controlY = controlY + (sourceRadius / 2)
        narrowWidth = (sourceRadius * 0.2)
      }
      else if (sourceRadius < targetRadius) {
        controlY = controlY + (targetRadius / 2)
        narrowWidth = (targetRadius * 0.2)
      }
      else {
        controlY = controlY + targetRadius
        narrowWidth = (targetRadius * 0.2)
      }

      controlY = ( controlY  +  narrowWidth)

      return { x: controlX, y: controlY }
    }
    function drawPath(d) {
      // console.log("d ->",d)
      const svg = d3.select(".connector");
      // const svg = d3.select("svg");
     
// console.log("Exp->",svg.select("#exploration-graph").select(".nodes").selectAll(".exploration-node"))
      var sourceNode = svg.select("#exploration-graph").select(".nodes").selectAll(".exploration-node").filter((data, i, nodes) => nodes[i].getAttribute("data-id") && nodes[i].getAttribute("data-id") == d.source.data.id);
      var targetNode = svg.select("#exploration-graph").select(".nodes").selectAll(".exploration-node").filter((data, i, nodes) => nodes[i].getAttribute("data-id") && nodes[i].getAttribute("data-id") == d.target.data.id);
      // console.log(sourceNode)
      // const r =parseInt(sourceNode.select("#cat_" + d.source.data.id).node().getAttribute("r"))
      // console.log("R->",r)
      // const sourceRadius = r
      var sourceRadius = parseInt(sourceNode.select("#cat_" + d.source.data.id).node().getAttribute("r"));
      var targetRadius = parseInt(targetNode.select("#cat_" + d.target.data.id).node().getAttribute("r"));
      const sourceX = d.source.y, sourceY = d.source.x - (sourceRadius);
      const targetX = d.target.y, targetY = d.target.x - (targetRadius);
      const sourceVariance = sourceRadius * 0.2
      const targetVariance = targetRadius * 0.2
      const controlX = (sourceX + targetX) / 2;  // Midpoint for smooth curves
      var controlY = (sourceY + targetY) / 2;  // Midpoint for smooth curves
      var narrowWidth = 5; // Narrower width in the middle
      if (sourceRadius > targetRadius) {
        controlY = controlY + (sourceRadius / 2)
        narrowWidth = (sourceRadius * 0.2)
      }
      else if (sourceRadius < targetRadius) {
        controlY = controlY + (targetRadius / 2)
        narrowWidth = (targetRadius * 0.2)
      }
      else {
        controlY = controlY + targetRadius
        narrowWidth = (targetRadius * 0.2)
      }
      return `M ${sourceX},${sourceY + sourceVariance} Q ${controlX},${controlY + narrowWidth}  ${targetX + (targetRadius * 0)},${targetY + (targetRadius * 0) + targetVariance} L ${targetX + (targetRadius * 0)},${targetY + (targetRadius * 2) - targetVariance} Q ${controlX},${controlY + (narrowWidth * 1)}  ${sourceX},${sourceY + (sourceRadius * 2) - sourceVariance} Z`;
    }

    function highlightBubbles(d, thisElement) {
     
      d.data.bubbles.forEach(bubble => {
        
        if (bubble.id == thisElement.getAttribute("data-id")) {
          bubble.predecessors.forEach(element => {
            var predecessors = svg.select("#exploration-graph").select(".nodes").selectAll(".bubble").filter((data, i, nodes) => nodes[i].getAttribute("data-id") && nodes[i].getAttribute("data-id") == element);
            predecessors.classed("circle-hovered-predecessors", true)
            // Tooltip.style("opacity", 1)
          });
        }

      });
      // d.data.predecessorIds.forEach(element => {
      //   var predecessors = d3.select("#exploration-graph").select(".nodes").selectAll(".bubble").filter((data, i, nodes) => nodes[i].getAttribute("data-id") && nodes[i].getAttribute("data-id") == element);
      //   // predecessors.classed("bubble", false)
      //   predecessors.classed("circle-clicked-predecessors", true)
      // });
      d.data.children.forEach(element => {
        // traverse(element)
        element.bubbles.forEach(bubble => {
          if (bubble.predecessors.includes(d3.select(thisElement).node().getAttribute("data-id"))) {
            var predecessors = svg.select("#exploration-graph").select(".nodes").selectAll(".bubble").filter((data, i, nodes) => nodes[i].getAttribute("data-id") && nodes[i].getAttribute("data-id") == bubble.id);
            // predecessors.classed("bubble", false)
            predecessors.classed("circle-hovered-predecessors", true)
          }
        });

      });

      function traverse(element) {
        element.bubbles.forEach(bubble => {
          if (bubble.predecessors.includes(d3.select(thisElement).node().getAttribute("data-id"))) {
            var predecessors = svg.select("#exploration-graph").select(".nodes").selectAll(".bubble").filter((data, i, nodes) => nodes[i].getAttribute("data-id") && nodes[i].getAttribute("data-id") == bubble.id);
            // predecessors.classed("bubble", false)
            predecessors.classed("circle-hovered-predecessors", true)
          }
        });
        if (element.children && element.children.length) {
          traverse(element)
        }
      }

    }
    function highlightBubblesClicked(d, thisElement) {
      // d3.select("#exploration-graph").select(".nodes").selectAll(".circle-clicked").classed("circle-clicked", false).classed("bubble", true)
      d3.select("#exploration-graph").select(".nodes").selectAll(".circle-clicked").classed("circle-clicked", false)

      d3.select(thisElement).classed("circle-hovered", false)
      // d3.select(thisElement).classed("bubble", false)
      d3.select(thisElement).classed("circle-clicked", true)
      // d3.select("#exploration-graph").select(".nodes").selectAll(".circle-hovered-predecessors").classed("circle-hovered-predecessors", false).classed("bubble", true)
      // d3.select("#exploration-graph").select(".nodes").selectAll(".circle-clicked-predecessors").classed("circle-clicked-predecessors", false).classed("bubble", true)
      d3.select("#exploration-graph").select(".nodes").selectAll(".circle-hovered-predecessors").classed("circle-hovered-predecessors", false)
      d3.select("#exploration-graph").select(".nodes").selectAll(".circle-clicked-predecessors").classed("circle-clicked-predecessors", false)
      d.data.bubbles.forEach(bubble => {
        if (bubble.id == thisElement.getAttribute("data-id")) {
          bubble.predecessors.forEach(element => {
            var predecessors = d3.select("#exploration-graph").select(".nodes").selectAll(".bubble").filter((data, i, nodes) => nodes[i].getAttribute("data-id") && nodes[i].getAttribute("data-id") == element);
            predecessors.classed("circle-clicked-predecessors", true)
          });
        }

      });
      // d.data.predecessorIds.forEach(element => {
      //   var predecessors = d3.select("#exploration-graph").select(".nodes").selectAll(".bubble").filter((data, i, nodes) => nodes[i].getAttribute("data-id") && nodes[i].getAttribute("data-id") == element);
      //   // predecessors.classed("bubble", false)
      //   predecessors.classed("circle-clicked-predecessors", true)
      // });


      d.data.children.forEach(element => {
        element.bubbles.forEach(bubble => {
          if (bubble.predecessors.includes(d3.select(thisElement).node().getAttribute("data-id"))) {
            var predecessors = svg.select("#exploration-graph").select(".nodes").selectAll(".bubble").filter((data, i, nodes) => nodes[i].getAttribute("data-id") && nodes[i].getAttribute("data-id") == bubble.id);
            // predecessors.classed("bubble", false)
            predecessors.classed("circle-clicked-predecessors", true)
          }
        });

      });


    }
    function dehighlightBubbles(d, thisElement) {
      d.data.predecessorIds.forEach(element => {
        var predecessors = svg.select("#exploration-graph").select(".nodes").selectAll(".circle-hovered-predecessors").filter((data, i, nodes) => nodes[i].getAttribute("data-id") && nodes[i].getAttribute("data-id") == element);

        predecessors.classed("circle-hovered-predecessors", false)
        // predecessors.classed("bubble", true)

      });

      d.data.children.forEach(element => {
        element.bubbles.forEach(bubble => {
          if (bubble.predecessors.includes(d3.select(thisElement).node().getAttribute("data-id"))) {
            var predecessors = svg.select("#exploration-graph").select(".nodes").selectAll(".circle-hovered-predecessors").filter((data, i, nodes) => nodes[i].getAttribute("data-id") && nodes[i].getAttribute("data-id") == bubble.id);
            predecessors.classed("circle-hovered-predecessors", false)
            // predecessors.classed("bubble", true)
          }
        });
      });
    }
    function getTotalCount(d) {
      var count = 0;
      d.data.bubbles.forEach(element => {
        count = count + element.count
      });
      return count
    }
  }



  contextMenu(event, node) {
    event.preventDefault();
    this.relationist = node.data
    let origin = document.getElementById("cat_" + node.data.id)
    let config = {
      data: {
        "template": this.contextList,
      }
    };
    this.contextListMenu = this.cdkoverlayDialog.openMenu(config, TemplateDropdownComponent, origin);
  }
  genRamdomNumber(d) {
    var count = d.data.count
    var childCount = 0
    d.data.bubbles.forEach(element => {
      childCount = childCount + element.count
    });
    if (childCount) {
      return childCount
    } else {
      return count
    }

  }

  checkMutualExclusive_Addfilter() {
    this.alertvarService.filters.forEach((obj) => {
      if (this.alertvarService.mutual_exclusive_filters.hasOwnProperty(obj.category)) {
        if (this.alertvarService.mutual_exclusive_filters[obj.category].hasOwnProperty(obj.label)) {
          this.alertvarService.mutual_exclusive_filters[obj.category][obj.label].isSelected = obj.isSelected
        }
      }
    })
  }


  categories_filters() {
  //   if(this.alertvarService.lastClickedNode.node == "Episodes"){
  //   this.alertvarService.selectedInstantFilter = JSON.parse(JSON.stringify(this.alertvarService.instantfilters["isInEpisode"]))
  // }
  // else{

//console.log("Last CLicked Node =---->", this.alertvarService.lastClickedNode.node)
//console.log("Instant Filter =---->",this.alertvarService.instantfilters)
//console.log("Selected Instant Filter =---->",this.alertvarService.selectedInstantFilter)

  if(Object.keys(this.alertvarService.selectedInstantFilter).length){
//console.log("Selected Instant Filter has values")
  }
// console.log("Instant -> ",this.alertvarService.instantfilters)
// console.log("Node -> ",this.alertvarService.lastClickedNode.node)
// console.log("Selected -> ",this.alertvarService.selectedInstantFilter)
    this.alertvarService.selectedInstantFilter = Object.keys(this.alertvarService.selectedInstantFilter).length ? this.alertvarService.selectedInstantFilter : JSON.parse(JSON.stringify(this.alertvarService.instantfilters[this.alertvarService.lastClickedNode.node]))



//console.log("Selected Instant Filter =---->",this.alertvarService.selectedInstantFilter)
  // }
    // this.alertvarService.filters = this.alertvarService.nodeinfo.instantFilter
    this.alertvarService.filters = [...this.alertvarService.nodeinfo.instantFilterDisplay]
    // this.alertvarService.applied_filters = this.alertvarService.nodeinfo.instantFilterDisplay
    this.alertvarService.mutual_exclusive_filters = JSON.parse(JSON.stringify(this.alertvarService.mutual_exclusive_filters_template))
    this.checkMutualExclusive_Addfilter()
    for (let filtername in this.alertvarService.selectedInstantFilter) {
      // this.alertvarService.filterpannelexpanded[filtername] = false;
      this.alertvarService.selectedInstantFilter[filtername].forEach((element, index) => {
        var result = this.alertvarService.filters.findIndex((obj) => { return obj.label == element.label && obj.category == element.category })
        if (result >= 0) {
          this.alertvarService.selectedInstantFilter[filtername][index].isSelected = true;
        }
      })
    };

    this.alertvarService.limitfilter_list = this.alertvarService.selectedInstantFilter.hasOwnProperty('limit') ? this.alertvarService.selectedInstantFilter['limit'].map(item => item.label) : [];
    // console.log(this.alertvarService.limitfilter_list)
    let limitstring = this.alertvarService.selectedInstantFilter.hasOwnProperty('limit') ? this.alertvarService.selectedInstantFilter['limit'].filter(item => item.isSelected == true).map(item => item.label)[0] : ""
    if (limitstring != undefined) {
      this.alertvarService.limitfilter.setValue(limitstring);
    } else {
      this.alertvarService.limitfilter.setValue('Show all');
    }

    // this.alertvarService.filterslist = this.alertvarService.filters.filter((obj) => obj.category != 'limit')

//console.log("Filter =---->",this.alertvarService.filterslist)
  }

  nodeClicked(node, selector) {
    if (!this.isAction || selector) {
      d3.select("#exploration-graph").select(".nodes").selectAll(".outer-circle-selected").classed("outer-circle-selected", false).classed("outer-circle", true)
      d3.select("#exploration-graph").select(".nodes").selectAll(".inner-circle-selected").classed("inner-circle-selected", false).classed("inner-circle", true)
      var selectedOuterCircle = d3.select("#exploration-graph").select(".nodes").select("#cat_" + node.data.id)
      var selectedInnerCircle = d3.select("#exploration-graph").select(".nodes").select("#inner_cat_" + node.data.id)
      selectedInnerCircle.classed("inner-circle", false)
      selectedInnerCircle.classed("inner-circle-selected", true)
      selectedOuterCircle.classed("outer-circle", false)
      selectedOuterCircle.classed("outer-circle-selected", true)
      this.alertvarService.lastClickedNode = node.data;
      // if (!(node.data.node == "other_series" || node.data.node == "fields"))
      this.NodeSelected.emit([selector, this.alertvarService.lastClickedNode])
      this.alertvarService.nodeSelected = true
      // this.alertvarService.selectedInstantFilter = {}
      // this.alertvarService.selectedInstantFilter = JSON.parse(JSON.stringify(this.alertvarService.instantfilters[this.alertvarService.lastClickedNode.relation]))
      // this.alertvarService.filters = this.alertvarService.nodeinfo.instantFilter
      // this.alertvarService.selectedInstantFilter.forEach((element, index) => {
      //   var result = this.alertvarService.filters.findIndex((obj) => { return obj.label == element.label })
      //   if (result >= 0) {
      //     this.alertvarService.selectedInstantFilter[index].isSelected = true
      //   }
      // });
      // console.log("selectedInstantFilter",this.alertvarService.selectedInstantFilter)

      this.categories_filters()
    }
  }

  openRelations(node) {
    // this.getRelations(node)
    // this.alertService.selectedNode = node;
    // if (!this.inProgress) {
    if(!this.isAction){
      if (!(node.data.node == "other_series")) {
            this.relationist = node.data

            let origin = document.getElementById("cir_anchor_" + node.data.id)
            let config = {
              data: {
                "template": this.relationList,
              }
            };
            this.relationListMenu = this.cdkoverlayDialog.openMenu(config, TemplateDropdownComponent, origin);
            
        }
      }
  }

  openInstantfilterOverlay(parentid:number,childid:number,relation:any,selectedMenuLabel:string){
    if (!this.isAction){
      this.selectedrelationMenuKey = selectedMenuLabel;
      this.closeInstantfilterOverlay()
      
      this.instantFilterOption = relation.instantFilter
      this.instantFilterParentId = parentid
      this.instantFilterChildId = childid
      let origin = document.getElementById("filter-"+parentid.toString()+'-'+childid.toString())
        let config = {
          data: {
            "template": this.instantfilter,
          },
          hasBackdrop:false
        };
        this.instantfilterMenu = this.cdkoverlayDialog.openNestedMenu(config, TemplateDropdownComponent, origin);
        this.relationListMenu.$closed.subscribe(()=>{
          this.selectedrelationMenuKey = ''
          this.instantfilterMenu.close()
        })
      }
  }

  closeInstantfilterOverlay(){
    if(this.instantfilterMenu){
      this.instantfilterMenu.close()
    }
  }
  addNode(instantFilter, node) {
    // console.log(relation, childName, instantFilter, node)
    node = this.relationist
    // console.log(relation)
    var childName = this.relationist.target_entity[this.instantFilterParentId]
    var relation= this.relationist.target_entity[this.instantFilterParentId].relations[this.instantFilterChildId]
    var currentNode = this.getObjectById(this.alertvarService.chartData, node.id)
    // var parentNode = this.getParentById(this.alertvarService.chartData, currentNode.id)
    var lastChildId;
    var branches
    if (currentNode.children.length) {
      lastChildId = currentNode.children[currentNode.children.length - 1].id
      branches = lastChildId.split("_")
      branches[branches.length - 1] = parseInt(branches[branches.length - 1]) + 1
    }
    else {
      lastChildId = currentNode.id
      branches = lastChildId.split("_")
      branches.push("1")
    }
    var predecessors = []
    // currentNode.bubbles.forEach(element => {
    //   predecessors.push(element.id)
    // });
    var newChild = {
      "id": branches.join("_"),
      "node": childName.label,
      "count": 0,
      "bubbles": [],
      "filters": [],
      "children": [],
      "predecessorIds": [],
      "relation": relation.label,
      "instantFilter": [instantFilter],
      "instantFilterDisplay": [instantFilter],
      "total_alert_count":0
    }
    currentNode.children.push(newChild)
    this.alertvarService.handleprovided3chartdataerror.resetError();
    // this.updateKeyInAllObjects(currentNode, "bubbles", [])
    // var parentNode = this.getBranchWithAncestors(this.alertvarService.chartData, newChild.id)
    var parentNode = this.getParentById(this.alertvarService.chartData,newChild.id)
      var formRoot = this.getBranchWithAncestors(this.alertvarService.chartData, newChild.id)
      
      var tempStructure = this.updateKeyInNestedObjects(formRoot, "bubbles", [])
      tempStructure = this.updateKeyInNestedObjects(tempStructure, "bubble_values", [])
      tempStructure = this.updateKeyInNestedObjects(tempStructure, "predecessorIds", [])
      tempStructure = this.updateKeyInNestedObjects(tempStructure, "target_entity", [])

    var req_obj = {
      "alert_id": this.alertvarService.alertscollapsedata.selectedalert.alertId,
      "hosts":this.alertvarService.alertscollapsedata.selectedalert.hosts,
      "platform" :this.alertvarService.alertscollapsedata.selectedalert.platform,
      "season_time": [this.timezoneservice.toUtcTimeZonefromUser(this.alertvarService.advanced_filter_values.start_time).format("YYYY-MM-DD HH:mm:ss"), this.timezoneservice.toUtcTimeZonefromUser(this.alertvarService.advanced_filter_values.end_time).format("YYYY-MM-DD HH:mm:ss")],
      "episode_duration": this.alertvarService.advanced_filter_values.time_interval.value,
      "threshold": this.alertvarService.bubbleThreshold,
      "parent_node": parentNode?parentNode.node:"",
      "template": tempStructure,
      "filters": this.alertvarService.getBubbleValues(currentNode),
      "relation": currentNode.relation,
      "updateNode": branches.join("_"),
      "isRoot":0,
      "ref_no":this.alertvarService.chart_ref_no
    }

    this.alertService.provided3chartevents.emitstate = 1;
    this.alertvarService.template_structure = tempStructure;
    this.alertService.provided3chartevents.postrequest(req_obj)

      .pipe(takeUntil(this.$destroy))
      .subscribe((data: any) => {
//console.log({data})
        // this.updateObjectById(this.alertvarService.chartData, currentNode.id, data)
          this.alertvarService.chart_ref_no = data.ref_no
        this.updateObjectById(this.alertvarService.chartData, data.template.id, data.template)

        setTimeout(() => {
          this.updateChart()
        }, 500);
      },
        (error) => {
          this.deleteObjectById(this.alertvarService.chartData, branches.join("_"))
          this.alertvarService.handleprovided3chartdataerror.seterror(true, error.error?.errmsg)
        })

    this.relationListMenu.close()
    this.instantfilterMenu.close()
    // this.alertvarService.chartData.children.push({'bubbles': [], 'count': 229, 'predecessorIds': [], 'id': '1_1', 'node': 'episodes', 'children': [], 'relation': 'relation', 'relationsList': [{'label': 'emitedby', 'direction': 'outgoing', 'relations': [{'label': 'source', 'direction': '', 'relations': []}, {'label': 'fields', 'direction': '', 'relations': []}]}, {'label': 'hasemited', 'direction': 'outgoing', 'relations': [{'label': 'episodes', 'direction': '', 'relations': []}]}, {'label': 'hasemited', 'direction': 'outgoing', 'relations': [{'label': 'episodes', 'direction': '', 'relations': []}, {'label': 'source', 'direction': '', 'relations': []}, {'label': 'series', 'direction': '', 'relations': []}]}]})
    // this.updateChart()

  }
  RemoveNode(node) {
    
    // this.contextListMenu.close()
    this.relationListMenu.close()
    let currentObject = this.getObjectById(this.alertvarService.chartData,node.id)
    let tempStructure = this.updateKeyInNestedObjects(currentObject, "bubbles", [])
    tempStructure = this.updateKeyInNestedObjects(tempStructure, "bubble_values", [])
    tempStructure = this.updateKeyInNestedObjects(tempStructure, "predecessorIds", [])
    tempStructure = this.updateKeyInNestedObjects(tempStructure, "target_entity", [])
    tempStructure = this.updateKeyInNestedObjects(tempStructure, "instantFilter", [])
    tempStructure = this.updateKeyInNestedObjects(tempStructure, "instantFilterDisplay", [])
    tempStructure = this.updateKeyInNestedObjects(tempStructure, "advanceFilter", [])
    tempStructure = this.updateKeyInNestedObjects(tempStructure, "advanceFilterDisplay", [])
    this.deleteObjectById(this.alertvarService.chartData, node.id)
    this.updateChart()
    var parentNode = this.getParentById(this.alertvarService.chartData,node.id)
    this.alertvarService.lastClickedNode = parentNode
// console.log("Node Clicked 3")
    this.nodeClicked({ "data": this.alertvarService.chartData }, 1)
    // this.alertService.removeNodePost({'updateNode':node.id,'template':tempStructure,"ref_no":this.alertvarService.chart_ref_no}).subscribe((data:any)=>{
    //   if(data.status==1){
    //     this.deleteObjectById(this.alertvarService.chartData, node.id)
    //     this.updateChart()
    //   }
    //   else{
    //     this.toastservice.show({
    //       text: "The removal action failed",
    //       type: ToastType.failure
    //     })
    //   }
    // })

  }
  updateNode() {
    var newData = { 'bubbles': [], 'count': 229, 'predecessorIds': [], 'id': '1_1', 'node': 'episodes', 'children': [], 'relation': 'relation', 'relationsList': [{ 'label': 'emitedby', 'direction': 'outgoing', 'relations': [{ 'label': 'source', 'direction': '', 'relations': [] }, { 'label': 'fields', 'direction': '', 'relations': [] }] }, { 'label': 'hasemited', 'direction': 'outgoing', 'relations': [{ 'label': 'episodes', 'direction': '', 'relations': [] }] }, { 'label': 'hasemited', 'direction': 'outgoing', 'relations': [{ 'label': 'episodes', 'direction': '', 'relations': [] }, { 'label': 'source', 'direction': '', 'relations': [] }, { 'label': 'series', 'direction': '', 'relations': [] }] }] }
    this.updateObjectById(this.alertvarService.chartData, "1_2", newData)
    this.updateChart()
  }

  // centerAlign() {
  //   const svg = d3.select(".connector").node().getBBox();
  //   const svgWidth = svg.width;
  //   const svgHeight = svg.height;

  //   const bbox = d3.select("#exploration-graph").node().getBBox();
  //   const graphWidth = bbox.width;
  //   const graphHeight = bbox.height;

  //   // Calculate the position to center the graph
  //   const centerX = (svgWidth / 2) - (graphWidth / 2);
  //   // const centerY = (svgHeight / 2) - (graphHeight / 2);
  //   const centerY = (svgHeight / 2);
  //   // Apply the translation
  //   d3.select("#exploration-graph").attr("transform", `translate(${centerX}, ${centerY})`);
  // }
  listhovered(index) {
    // const element = this.hoverElements.toArray()[index].nativeElement;
    // const style = element.getBoundingClientRect();

  }
  getObjectById(obj, id) {
    if (obj.id === id) return obj; // Base case: found the object

    if (obj.children && obj.children.length > 0) {
      for (const child of obj.children) {
        const result = this.getObjectById(child, id);
        if (result) return result; // If found in any child, return it
      }
    }
    return null; // If not found
  }
  getParentById(obj, childId) {
    if (obj.id === childId) return null; // Base case: found the object

    // If the current object has children, check each child
    if (obj.children && obj.children.length > 0) {
      for (const child of obj.children) {
        if (child.id === childId) {
          return obj; // Return current object as it is the parent
        }

        // Recursively search in children
        const result = this.getParentById(child, childId);
        if (result) return result; // If found in deeper levels, return the parent
      }
    }
    return null; // If no parent is found
  }
  updateObjectById(obj, id, newData) {
    const objectToUpdate = this.getObjectById(obj, id);
    if (objectToUpdate) {
      Object.assign(objectToUpdate, newData); // Merge newData into the found object
    } else {
//console.log("Object not found");
    }
  }
  deleteObjectById(obj, id) {
    if (obj.children && obj.children.length) {
      obj.children = obj.children.filter(child => child.id !== id); // Remove the child with the matching id
      for (const child of obj.children) {
        this.deleteObjectById(child, id); // Recursively check for nested children
      }
    }
  }
  addChildObject(obj, parentId, newChild) {
    const parentNode = this.getObjectById(obj, parentId); // Reuse getObjectById function
    if (parentNode) {
      // Check if the parent node has a children array, if not, initialize it
      if (!parentNode.children) {
        parentNode.children = [];
      }
      parentNode.children.push(newChild); // Add the new child to the parent's children
    } else {
//console.log("Parent node not found");
    }
  }
  updateKeyInAllObjects(obj, key, newValue) {
    // Check if the current object has the key, and update it
    if (obj.hasOwnProperty(key)) {
      obj[key] = newValue;
    }

    // If the object has children, recursively update the key in them
    if (obj.children && obj.children.length > 0) {
      for (const child of obj.children) {
        this.updateKeyInAllObjects(child, key, newValue);
      }
    }
  }
  updateKeyInNestedObjects(obj, key, newValue) {
    // Create a deep copy of the object to avoid modifying the original
    const newObj = structuredClone(obj);

    // Helper function to update the key in a cloned object
    function updateKeyRecursively(obj) {
      // Update the key if it exists in the current object
      if (obj.hasOwnProperty(key)) {
        obj[key] = newValue;
      }

      // Recursively update the key in children, if they exist
      if (obj.children && obj.children.length > 0) {
        for (const child of obj.children) {
          updateKeyRecursively(child);
        }
      }
    }

    updateKeyRecursively(newObj); // Update the cloned object
    return newObj; // Return the modified clone
  }

  getAllValuesByKey(obj, key) {
    const values = [];
  
    function collectValues(node) {
      // If the key exists in the current object, add its value to the array
      if (node.hasOwnProperty(key)) {
        values.push(node[key]);
      }
  
      // Recursively collect values from children, if they exist
      if (node.children && node.children.length > 0) {
        for (const child of node.children) {
          collectValues(child);
        }
      }
    }
  
    collectValues(obj); // Start the recursion
    return values; // Return the collected values
  }
  getBranchWithAncestors(obj, id, parentChain = []) {
    // If the current node matches the given id, return the subtree with its ancestors
    if (obj.id === id) {
      // Reconstruct the branch by appending ancestors
      let branch = structuredClone(obj);
      for (let i = parentChain.length - 1; i >= 0; i--) {
        branch = { ...structuredClone(parentChain[i]), children: [branch] };
      }
      return branch;
    }
  
    // If the node has children, search recursively while keeping track of ancestors
    if (obj.children && obj.children.length > 0) {
      for (const child of obj.children) {
        const result = this.getBranchWithAncestors(child, id, [...parentChain, obj]); // Pass current node as an ancestor
        if (result) return result; // If found, return the reconstructed branch
      }
    }
  
    return null; // Return null if not found
  }
  openOverlay_moreoptions_click(template, origin): void {
    // this.moreOptionState = true
    // let config = {
    //   data: {
    //     "template": template,
    //   }
    // }
    // this.dialogRef = this.cdkoverlayDialog.openMenu(config, TemplateDropdownComponent, origin);
    this.moreOptionState = !this.moreOptionState
  }
  closeOptions_click() {
    if (this.dialogRef) {
      this.dialogRef.close()
      this.moreOptionState = false
    }
  }
  changeTemplate(template) {
    this.templateRef.close()
    this.closeOptions_click()
    this.alertvarService.chart_ref_no=""
    this.alertvarService.chartData = template.temp
    var req_obj = {
      "alert_id": this.alertvarService.alertscollapsedata.selectedalert.alertId,
      "hosts":this.alertvarService.alertscollapsedata.selectedalert.hosts,
      "platform" :this.alertvarService.alertscollapsedata.selectedalert.platform,
      "season_time": [this.timezoneservice.toUtcTimeZonefromUser(this.alertvarService.advanced_filter_values.start_time).format("YYYY-MM-DD HH:mm:ss"), this.timezoneservice.toUtcTimeZonefromUser(this.alertvarService.advanced_filter_values.end_time).format("YYYY-MM-DD HH:mm:ss")],
      "episode_duration": this.alertvarService.advanced_filter_values.time_interval.value,
      "threshold": this.alertvarService.bubbleThreshold,
      "parent_node": "",
      "isRoot":1,
      "template": template.temp,
      "relation": template.temp.relation,
      "updateNode": template.temp.id,
      "ref_no":this.alertvarService.chart_ref_no,
      "timeZone":this.sharedService.timeZone
    }
    this.alertvarService.template_structure = template.temp;
    this.alertService.updated3chartevents.postrequest(req_obj)
      .pipe(takeUntil(this.$destroy))
      .subscribe((data: any) => {
        this.alertvarService.chart_ref_no = data.ref_no
        this.updateObjectById(this.alertvarService.chartData, data.template.id, data.template)
        // this.updateObjectById(this.alertvarService.chartData, data.id, data)
        // setTimeout(() => {
          this.updateChart()
// console.log("Node Clicked 4")
          this.nodeClicked({ "data": this.alertvarService.chartData }, 1)
        // }, 500);
      }, (error) => {
        this.alertvarService.handleprovided3chartdataerror.seterror(true, error.error?.errmsg)
      })
  }
  openOverlay_templates(template, origin) {
    if (!this.isAction) {
      let config = {
        data: {
          "template": template,
        }
      }
      this.templateRef = this.cdkoverlayDialog.openMenu(config, TemplateDropdownComponent, origin);
    }
  }
  openOverlay_preview(template, origin) {
    let config = {
      data: {
        "template": template,
      }
    }
    this.visualizeRef = this.cdkoverlayDialog.openMenu(config, TemplateDropdownComponent, origin);
    setTimeout(() => {
      var Nodedata = this.getNodeChartData()
      this.myChart = echarts.init(document.getElementById("nodeChart"));
      this.myChart.setOption({
        xAxis: {
          data: Nodedata.axisData
        },
        series: {
          data: Nodedata.seriesData
        }
      })
    }, 200);
  }
  clearSvg() {
    if (!this.isAction) {
      d3.select(".connector").selectAll("#exploration-graph").select(".links").selectAll("*").remove()
      d3.select(".connector").selectAll("#exploration-graph").select(".nodes").selectAll("*").remove()
      this.alertvarService.chartData = {}
      this.alertvarService.load_default_chartdata();
    }
  }

  resetFilters(){
    this.alertvarService.filterslist=[]
    this.alertvarService.selectedInstantFilter.time.forEach(filter=>{
      
      if(filter.hasOwnProperty("isSelected")){
        delete filter.isSelected
      }
// console.log(filter)
    })
    // this.alertvarService.filterpannelexpanded["time"] = !this.alertvarService.filterpannelexpanded["time"]
// console.log(this.alertvarService.filterpannelexpanded)
// console.log(this.alertvarService.selectedInstantFilter)
// console.log(this.alertvarService.filters)
// console.log(this.alertvarService.filterslist)
    
  }

  reset() {
    // var temp = this.getObjectById(this.alertvarService.chartData, this.alertvarService.chartData.id)
    if(!this.isAction){
      this.alertvarService.resetPreviousNodeSelection()
      var temp = JSON.parse(JSON.stringify(this.alertvarService.templates[0].temp))
      this.alertvarService.nodeinfo = temp
      this.alertvarService.nodeinfo.children = []
      this.alertvarService.nodeinfo.filters = []
      var tempStructure = this.updateKeyInNestedObjects(this.alertvarService.nodeinfo, "bubbles", [])
      tempStructure = this.updateKeyInNestedObjects(tempStructure, "bubble_values", [])
      tempStructure = this.updateKeyInNestedObjects(tempStructure, "predecessorIds", [])
      tempStructure = this.updateKeyInNestedObjects(tempStructure, "target_entity", [])

      this.alertvarService.chart_ref_no=""
      var req_obj = {
        "alert_id": this.alertvarService.alertscollapsedata.selectedalert.alertId,
        "hosts":this.alertvarService.alertscollapsedata.selectedalert.hosts,
        "platform" :this.alertvarService.alertscollapsedata.selectedalert.platform,
        "season_time": [this.timezoneservice.toUtcTimeZonefromUser(this.alertvarService.advanced_filter_values.start_time).format("YYYY-MM-DD HH:mm:ss"), this.timezoneservice.toUtcTimeZonefromUser(this.alertvarService.advanced_filter_values.end_time).format("YYYY-MM-DD HH:mm:ss")],
        "episode_duration": this.alertvarService.advanced_filter_values.time_interval.value,
        "threshold": this.alertvarService.bubbleThreshold,
        "parent_node": "",
        "template": tempStructure,
        "relation": tempStructure.relation,
        "updateNode": tempStructure.id,
        "isRoot":1,
        "ref_no":this.alertvarService.chart_ref_no,
        "timeZone":this.sharedService.timeZone
      }
      this.alertvarService.template_structure = tempStructure;
      this.alertService.updated3chartevents.postrequest(req_obj)
        .pipe(takeUntil(this.$destroy))
        .subscribe((data: any) => {
          this.alertvarService.chart_ref_no = data.ref_no
          this.updateObjectById(this.alertvarService.chartData, data.template.id, data.template)
          // setTimeout(() => {
            this.updateChart()
// console.log("Node Clicked 5")
            this.nodeClicked({ "data": this.alertvarService.chartData }, 1)
            this.resetFilters()
          // }, 500);
        }, (error) => {
          this.alertvarService.handleprovided3chartdataerror.seterror(true, error.error?.errmsg)
        })
        
    }
    
  }

  getNodeChartData() {
    var axisData = []
    var seriesData = []
    if (this.alertvarService.lastClickedNode) {

      if (this.alertvarService.lastClickedNode.node == "episodes") {
        this.alertvarService.lastClickedNode.bubbles.forEach(element => {
          var d = this.timezoneservice.toUserTimeZone(parseInt(element.value)).format("MMM DD HH:mm")
          axisData.push(d)
          seriesData.push(element.count)
        });

      }
      else {
        this.alertvarService.lastClickedNode.bubbles.forEach(element => {
          seriesData.push(element.count)
          axisData.push(element.value)
        });
      }


    }
    return { "axisData": axisData, "seriesData": seriesData }
  }
  openPreview() {
    // this.openOverlay_moreoptions_click(this.moreOptionRef, this.moreOptionOrigin)
    setTimeout(() => {
      this.openOverlay_preview(this.visualizeRefTemp, this.visualizeOptionOrigin)

    }, 500);
  }
  showLegend() {
    this.alertvarService.legendState = !this.alertvarService.legendState
  }
  cancel_relationChart() {
    this.alertvarService.handleDetaildataerror.seterror(true, this.alertvarService.alertsheetmeta.noDatamsg[2]);
    this.alertService.provided3chartevents.cancelRequest();
  }

  // openAdvancedFilter(origin: any,mode:number) {
  //   // console.log("openAdvancedFilter======", !this.isAction, this.alertvarService.advanced_filter_values, this.alertvarService.alertsheetmeta.filterOptions.advanceFilter)

  //   if (!this.isAction) {
  //     const ref: cdkOverlayRef = this.openOverlay(origin, AdvanceFilterComponent,
  //       [
  //         { ...this.alertvarService.advanced_filter_values },
  //         { ...this.alertvarService.alertsheetmeta.filterOptions.advanceFilter },mode]
  //       , mode?["45vh", "25vw"]:["45vh", "55vw"]);
  //       // , ["45vh", "25vw"]);
  //     ref.$selectedValue.subscribe(response => {
  //       this.alertvarService.advanced_filter_values = response;
  //       this.alertvarService.advancedFilterChange.next(null);
  //     })
  //   }
  // }

  openOverlay(origin: any, component: any, componentInputs: any, dimensions: any) {
    this.overLayRef = this.cdkoverlayDialog.open({
      data: componentInputs,
      height: dimensions[0],
      width: dimensions[1],
    },
      origin, component)
    return this.overLayRef;
  }

  get_total_episode_count(key:string){
    if(this.alertvarService.overviewDetails.length>0){
      if(this.alertvarService.overviewDetails[1].hasOwnProperty(key)){
        if(this.alertvarService.overviewDetails[1][key] == 0){
          return 0
        }
        else{
          return this.alertvarService.overviewDetails[1][key] - this.alertvarService.rootNodeEpisodesCount
        }
      }
      else{
        return 0
      }
    }
    else{
      return 0
    }
  }

  getdatetimeFormat(timeval:string){
    if(this.timezoneservice.toUserTimeZone(parseInt(timeval)).format("YYYY MMM DD") === this.timezoneservice.toUserTimeZone(parseInt(timeval) + (60 * this.alertvarService.advanced_filter_values.time_interval.value)).format("YYYY MMM DD")){
            
      return this.timezoneservice.toUserTimeZone(parseInt(timeval)).format("YYYY MMM DD HH:mm") + " - " + this.timezoneservice.toUserTimeZone(parseInt(timeval) + (60 * this.alertvarService.advanced_filter_values.time_interval.value)).format("HH:mm")   //"2025 Jan 25 21:00 - 21:10",
    }
    else{
      if(this.timezoneservice.toUserTimeZone(parseInt(timeval) + (60 * this.alertvarService.advanced_filter_values.time_interval.value)).format("HH:mm") == '00:00'){
        return this.timezoneservice.toUserTimeZone(parseInt(timeval)).format("YYYY MMM DD HH:mm") + " - " + this.timezoneservice.toUserTimeZone(parseInt(timeval) + (60 * this.alertvarService.advanced_filter_values.time_interval.value)).format("HH:mm")   //"2025 Jan 25 21:00 - 21:10",
      }
      else{
        return this.timezoneservice.toUserTimeZone(parseInt(timeval)).format("YYYY MMM DD HH:mm") + " - " + this.timezoneservice.toUserTimeZone(parseInt(timeval) + (60 * this.alertvarService.advanced_filter_values.time_interval.value)).format("YYYY MMM DD HH:mm")   //"2025 Jan 25 22:00 - 2025 Jan 26 01:00",
      }
    }
  }

  calculateAlertLowestHighetsInsightInfo(entity_fields:any,data:any){
    let rootNodeEntityFields = []
    entity_fields.forEach((item:any)=>{
      if(item['label'] != 'Episodes'){
        rootNodeEntityFields.push(item['label'])
      }
      
    })
    this.alertvarService.rootNodeEntityFields = rootNodeEntityFields
    let alertNonEntityFields =[]
    this.alertvarService.eventFieldOptions.forEach((item:any)=>{
      // console.log("this.alertvarService.eventFieldOptions===",item['value']['disp'],rootNodeEntityFields.indexOf(item['value']['disp']))
      if(rootNodeEntityFields.indexOf(item['value']['field']) == -1){
        alertNonEntityFields.push(item['value']['field'])
      }
    })
    this.alertvarService.alertNonEntityFields = alertNonEntityFields


    this.alertvarService.alertInsightTable = []
    
    let highest_bubbles = data.reduce((max, obj) => (obj.count > max.count ? obj : max), data[0]);
    let lowest_bubbles = data.reduce((min, obj) => (obj.count < min.count ? obj : min), data[0]);
    let total = data.reduce((sum, obj) => sum + (obj.count || 0), 0); 
    
    this.alertvarService.alertInsightTable=[{
      "metric":"Episode with Highest Alerts",
      "time_tange":highest_bubbles?this.getdatetimeFormat(highest_bubbles.value):"Not applicable",
      "alerts_count":highest_bubbles?this.alertvarService.numberWithCommas(highest_bubbles.count):"0",
      "percentage":highest_bubbles?((highest_bubbles.count/total)*100).toFixed(2).toString():"0",
    },
    {
      "metric":"Episode with Lowest Alerts",
      "time_tange":lowest_bubbles?this.getdatetimeFormat(lowest_bubbles.value):"Not applicable",
      "alerts_count":lowest_bubbles?this.alertvarService.numberWithCommas(lowest_bubbles.count):"0",
      "percentage":lowest_bubbles?((lowest_bubbles.count/total)*100).toFixed(2).toString():"0",
}]


  }



  // poc parent,child overlay munipulate

  // overlayRefs: Map<string, OverlayRef> = new Map();
  // activeMenu: any | null = null;
  // closeMenu(menuId) {
  //   const overlayRef = this.overlayRefs.get(menuId);
  //   if (overlayRef) {
  //     overlayRef.detach();
  //     overlayRef.dispose();
  //     this.overlayRefs.delete(menuId);
  //   }
  //   if (this.activeMenu === menuId) {
  //     this.activeMenu = null;
  //   }
  // }


  // toggleMenu(event: MouseEvent, menuId:string,relation:any){
  //   console.log(menuId,relation)
  //   this.instantFilterOption = relation
  //   if (this.activeMenu === menuId) {
  //     this.closeMenu(menuId);
  //     return;
  //   }

  //   this.closeAllMenus(); // Close other open menus

  //   const overlayRef = this.createOverlay(event);
  //   // console.log(this.relationList)
  //   // const templateRef = this.relationList.find(template) => {
  //   //   console.log()
  //   // });
  //   // if (!templateRef) {
  //   //   console.error('TemplateRef not found for menuId:', menuId);
  //   //   return;
  //   // }
  //   const templatePortal = new TemplatePortal(
  //     this.instantfilter,
  //     this.viewContainerRef
  //   );
  //   console.log(templatePortal)
  //   overlayRef.attach(templatePortal);
  //   this.overlayRefs.set(menuId, overlayRef);
  //   this.activeMenu = menuId;


  // }
  // private createOverlay(event: MouseEvent): OverlayRef {
  //     return this.overlay.create({
  //       positionStrategy: this.overlay.position()
  //         .flexibleConnectedTo({ x: event.clientX, y: event.clientY })
  //         .withPositions([
  //           {
  //             originX: 'start',
  //             originY: 'bottom',
  //             overlayX: 'start',
  //             overlayY: 'top',
  //           },
  //         ]),
  //       hasBackdrop: false,
  //       scrollStrategy: this.overlay.scrollStrategies.reposition(),
  //     });
  //   }
  //   closeAllMenus() {
  //     this.overlayRefs.forEach((ref, key) => {
  //       this.closeMenu(key);
  //     });
  //   }

}






// import { AfterViewInit, Component, ElementRef, EventEmitter, OnDestroy, OnInit, Output, QueryList, TemplateRef, ViewChild ,ViewContainerRef} from '@angular/core';
// import * as d3 from 'node_modules/d3'
// import { CdkOverlyayService } from 'src/app/shared/custom-overlay/cdk-overlyay.service';
// import { TemplateDropdownComponent } from 'src/app/shared/custom-overlay/template-dropdown/template-dropdown.component';
// // import { UserLoginService } from '../user-login.service';
// import { distinctUntilChanged, takeUntil } from 'rxjs/operators';
// import { Subject } from 'rxjs';
// import { AlertsvarService } from '../alertsvar.service';
// import { AlertsService } from '../alerts-custom.service';
// import * as echarts from "echarts";
// import { TimeZoneService } from 'src/app/services/time-zone.service';
// import { Overlay,OverlayRef } from '@angular/cdk/overlay';
// import { TemplatePortal } from '@angular/cdk/portal';



// @Component({
//   selector: 'app-relation-chart',
//   templateUrl: './relation-chart.component.html',
//   styleUrls: ['./relation-chart.component.scss']
// })
// export class RelationChartComponent implements OnInit, AfterViewInit, OnDestroy {
//   relationist
//   @Output() NodeSelected: EventEmitter<any> = new EventEmitter();

//   @ViewChild('relationList',{ static: false }) relationList: TemplateRef<any>;
//   @ViewChild('instantfilter',{ static: false }) instantfilter: TemplateRef<any>;
//   @ViewChild('contextList') contextList: ElementRef;
//   @ViewChild('moreOptionOrigin') moreOptionOrigin: ElementRef;
//   @ViewChild('moreOptionRef') moreOptionRef: ElementRef;
//   @ViewChild('visualizeOptionOrigin') visualizeOptionOrigin: ElementRef;
//   @ViewChild('visualizeRef') visualizeRefTemp: ElementRef;
//   @ViewChild('legendOptionOrigin') legendOrigin: ElementRef;
//   @ViewChild('legendRef') legendRefTemp: ElementRef;

//   data = {}
//   instantFilterOption;
//   relationListMenu;
//   instantfilterMenu;
//   contextListMenu;
//   moreOptionState: boolean = false;
//   dialogRef;
//   templateRef;
//   legendRef;
//   visualizeRef;
//   legends = [
//     { color: ['#c59393'], label: 'Selected entity',value:'',showCnt:false},
//     { color: ['#888'], label: 'Has alerts',value:'has_alerts',showCnt:true },
//     { color: ['rgb(211, 211, 211)'], label: 'Has no alerts',value:'has_no_alerts',showCnt:true },
//     { color: ['#13abec', '#136aec'], label: 'Selected relations',value:'',showCnt:false },
//     // { color: ['#f0c400'], label: 'Highlighted' },
//     // { color: ['#136aec'], label: 'Selected relations' },
//     { color: ['#f0c400', '#4b0'], label: 'Highlighted relations' ,value:'',showCnt:false}
//   ];
//   chartOption = {
//     tooltip: {
//       trigger: 'item'
//     },
//     xAxis: {
//       type: 'category',
//       data: []
//     },
//     yAxis: {
//       type: 'value'
//     },
//     series: [
//       {
//         data: [],
//         type: 'bar'
//       }
//     ]
//   };

//   myChart
//   constructor(
//     private viewContainerRef: ViewContainerRef,
//     private overlay: Overlay,
//     private cdkoverlayDialog: CdkOverlyayService,
//     public alertvarService: AlertsvarService,
//     public alertService: AlertsService,
//     private timezoneservice: TimeZoneService
//   ) { }
//   $destroy: Subject<boolean> = new Subject();
//   isAction: boolean = this.alertvarService.alertactionmanagement.procressProgress();

//   ngAfterViewInit(): void {
//     this.alertvarService.nodeSelected = false

//     this.openOverlay_moreoptions_click(this.moreOptionRef, this.moreOptionOrigin)

//     // setTimeout(() => {
//     //   this.openOverlay_templates(this.legendRefTemp, this.legendOrigin)

//     // }, 500);
//     this.alertService.provided3chartevents.isProgress$.pipe(takeUntil(this.$destroy)).subscribe((progress: boolean) => {
//       this.alertvarService.alertactionmanagement.updateAction.next(['chartprogress', progress]);
//     })
//     this.alertService.updated3chartevents.isProgress$.pipe(takeUntil(this.$destroy)).subscribe((progress: boolean) => {
//       this.alertvarService.alertactionmanagement.updateAction.next(['chartprogress', progress]);
//     })

//     this.alertvarService.alertactionmanagement.actionManagement
//       .pipe(distinctUntilChanged()).pipe(takeUntil(this.$destroy)).subscribe((progress: boolean) => {
//         this.isAction = progress;
//       })

//     this.initiateChart()
//     this.alertvarService.handleprovided3chartdataerror.resetError();
//     //empty bubbles in all the nodes
//     var tempStructure = this.updateKeyInNestedObjects(this.alertvarService.chartData, "bubbles", [])
//     tempStructure = this.updateKeyInNestedObjects(tempStructure, "bubble_values", [])
//     tempStructure = this.updateKeyInNestedObjects(tempStructure, "predecessorIds", [])
//     tempStructure = this.updateKeyInNestedObjects(tempStructure, "target_entity", [])


//     var req_obj = {
//       "alert_id": this.alertvarService.alertscollapsedata.selectedalert.alertId,

//       "season_time": [this.timezoneservice.toUtcTimeZonefromUser(this.alertvarService.advanced_filter_values.start_time).format("YYYY-MM-DD HH:mm:ss"), this.alertvarService.advanced_filter_values.end_time],
//       "episode_duration": this.alertvarService.advanced_filter_values.time_interval.value,
//       "threshold": this.alertvarService.bubbleThreshold,
//       "parent_node": "",
//       "template": tempStructure,

//       // "filters": [],
//       "relation": "isInEpisode",
//       "new_node": ""

//       // "token": "74e6ec28",
//       // "request_type": "process"


//     }
//     this.alertService.updated3chartevents.postrequest(req_obj)
//       .pipe(takeUntil(this.$destroy))
//       .subscribe((data: any) => {
//         this.updateObjectById(this.alertvarService.chartData, data.id, data)
//         setTimeout(() => {
//           this.updateChart()
//           this.nodeClicked({ "data": this.alertvarService.chartData }, 1)
//         }, 500);
//       }, (error) => {
//         this.alertvarService.handleprovided3chartdataerror.seterror(true, error.error?.errmsg)
//       })




//     this.alertvarService.advancedFilterChange.subscribe((data) => {

//       this.alertvarService.handleprovided3chartdataerror.resetError();
//       //empty all bubbles
//       var tempStructure = this.updateKeyInNestedObjects(this.alertvarService.chartData, "bubbles", [])
//       tempStructure = this.updateKeyInNestedObjects(tempStructure, "bubble_values", [])
//       tempStructure = this.updateKeyInNestedObjects(tempStructure, "filters", [])
//       tempStructure = this.updateKeyInNestedObjects(tempStructure, "predecessorIds", [])
//       tempStructure = this.updateKeyInNestedObjects(tempStructure, "target_entity", [])
//       var req_obj = {
//         "alert_id": this.alertvarService.alertscollapsedata.selectedalert.alertId,

//         "season_time": [this.timezoneservice.toUtcTimeZonefromUser(this.alertvarService.advanced_filter_values.start_time).format("YYYY-MM-DD HH:mm:ss"), this.alertvarService.advanced_filter_values.end_time],
//         "episode_duration": this.alertvarService.advanced_filter_values.time_interval.value,
//         "threshold": this.alertvarService.bubbleThreshold,
//         "parent_node": "",
//         "template": tempStructure,
//         // "filters": [],
//         "relation": "emitted",
//         "new_node": ""
//       }
//       this.alertService.updated3chartevents.postrequest(req_obj)
//         .pipe(takeUntil(this.$destroy))
//         .subscribe((data: any) => {
//           this.updateObjectById(this.alertvarService.chartData, data.id, data)
//           setTimeout(() => {
//             this.updateChart()
//             this.NodeSelected.emit([0, this.getObjectById(this.alertvarService.chartData, this.alertvarService.lastClickedNode.id)]);
//           }, 500);
//         }, (error) => {
//           this.alertvarService.handleprovided3chartdataerror.seterror(true, error.error?.errmsg)
//         })
//     })

//     this.alertvarService.nodeFilter.subscribe((data) => {
//       this.alertvarService.nodeinfo.filters = data
//       this.alertvarService.handleprovided3chartdataerror.resetError();
//       var parentNode = this.getParentById(this.alertvarService.chartData, this.alertvarService.nodeinfo.id)

//       var tempStructure = this.updateKeyInNestedObjects(this.alertvarService.nodeinfo, "bubbles", [])
//       tempStructure = this.updateKeyInNestedObjects(tempStructure, "bubble_values", [])
//       tempStructure = this.updateKeyInNestedObjects(tempStructure, "predecessorIds", [])
//       tempStructure = this.updateKeyInNestedObjects(tempStructure, "target_entity", [])

//       //piioi

//       var req_obj = {
//         "alert_id": this.alertvarService.alertscollapsedata.selectedalert.alertId,
//         "hosts":this.alertvarService.alertscollapsedata.selectedalert.hosts,
//         "platform":this.alertvarService.alertscollapsedata.selectedalert.platform,
//         "season_time": [this.timezoneservice.toUtcTimeZonefromUser(this.alertvarService.advanced_filter_values.start_time).format("YYYY-MM-DD HH:mm:ss"), this.alertvarService.advanced_filter_values.end_time],
//         "episode_duration": this.alertvarService.advanced_filter_values.time_interval.value,
//         "threshold": this.alertvarService.bubbleThreshold,
//         "parent_node": parentNode ? parentNode.node : "",
//         "template": tempStructure,
//         // "filters": data,
//         "relation": this.alertvarService.nodeinfo.relation,
//         "new_node": ""
//       }
//       this.alertService.updated3chartevents.postrequest(req_obj)
//         .pipe(takeUntil(this.$destroy))
//         .subscribe((data: any) => {
//           this.updateObjectById(this.alertvarService.chartData, data.id, data)
//           setTimeout(() => {
//             this.updateChart()
//             this.NodeSelected.emit([0, this.getObjectById(this.alertvarService.chartData, this.alertvarService.lastClickedNode.id)]);
//             this.alertvarService.nodeSelected = true
//           }, 500);
//         }, (error) => {
//           this.alertvarService.handleprovided3chartdataerror.seterror(true, error.error?.errmsg)
//         })
//     })
//     this.alertvarService.centerAlign()
//   }
//   ngOnInit(): void {
//   }
//   ngOnDestroy(): void {
//     this.alertvarService.handleprovided3chartdataerror.resetError();
//     this.$destroy.next()
//   }
//   initiateChart() {
//     var svg = d3.select(".connector")
//     const width = parseInt(d3.style(svg.node(), "width").replace('px', ''));
//     const height = parseInt(d3.style(svg.node(), "height").replace('px', ''));
//     svg.select("#exploration-zoom-pan-canvas").call(d3.drag()
//       .on('start', dragStart)
//       .on('drag', dragging)
//       .on('end', dragEnd))
//       .call(d3.zoom()
//         .extent([[0, 0], [width, height]])
//         .scaleExtent([0.5, 2])
//         .on("zoom", zoomed))
//       .on("dblclick.zoom", null);


//     let initialX, initialY, initialK;
//     let offsetX, offsetY;
//     function zoomed({ transform }) {
//       const currentTransform = d3.style(d3.select("#exploration-graph").node(), "transform").replace(/matrix\(|\)/g, '').split(",")
//       svg.select('#exploration-graph').attr("transform", "translate(" + (parseFloat(currentTransform[currentTransform.length - 2])) + "," + (parseFloat(currentTransform[currentTransform.length - 1])) + ") scale(" + transform.k + "," + transform.k + ")");
//       // svg.select('#exploration-graph').attr("transform", transform);
//     }
//     function dragStart(event, d) {
//       // svg.select("#exploration-graph").attr("stroke", "grey");
//       const currentTransform = d3.style(d3.select("#exploration-graph").node(), "transform").replace(/matrix\(|\)/g, '').split(",")
//       initialX = parseFloat(currentTransform[currentTransform.length - 2]);
//       offsetX = event.x;
//       initialY = parseFloat(currentTransform[currentTransform.length - 1]);
//       offsetY = event.y;
//       initialK = parseFloat(currentTransform[0]);
//     }
//     function dragging(event, d) {
//       var newCoordinate = "translate(" + (initialX + (event.x - offsetX)) + "," + (initialY + (event.y - offsetY)) + ") scale(" + initialK + "," + initialK + ")"
//       d3.select("#exploration-graph").attr("transform", newCoordinate);
//     }
//     function dragEnd(event, d) {
//       // d3.select("#exploration-graph").attr("stroke", null);
//     }
//   }
//   updateChart() {
//     var root = d3.hierarchy(this.alertvarService.chartData)
//     var treeLayout = d3.tree().size([0, 0]).nodeSize([150, 300]);
//     treeLayout(root);
//     let nodeRadius = 50;
//     var svg = d3.select(".connector");
    


//     let nodes = svg.select('g.nodes')
//       .selectAll('.exploration-node')
//       .data(root.descendants(), d => d.data.id)
//       .join(
//         enter => enter.append("g")
//           .attr('transform', d => `translate(${d.y},${d.x})`)
//           .attr("data-id", d => d.data.id)
//           .attr("id", d => d.data.id)
//           .classed("exploration-node", true)
//           .on("mouseover", function (event, d) {
//             d3.select(this).select("#cat_" + d.data.id).style("visibility", "visible")
//             d3.select(this).select('#grp_cir1_rect').select(".cir_anchor").style("visibility", "visible")
//             d3.select(this).select('#grp_cir1_rect').select("text").style("visibility", "visible")
//             // .attr("transform", "translate(" + (nodeRadius + (nodeRadius * 0.1)).toString() + ",0)")
//           })
//           .on("mouseout", function (event, d) {
//             d3.select(this).select("#cat_" + d.data.id).style("visibility", "hidden")
//             d3.select(this).select('#grp_cir1_rect').select(".cir_anchor").style("visibility", "hidden")
//             d3.select(this).select('#grp_cir1_rect').select("text").style("visibility", "hidden")
//             // d3.select(this).select('#grp_cir1_rect')
//             //   .attr("transform", "translate(15,0)")
//           })

//           // Apply styles and properties to new nodes
//           .call(enter => enter.append("g").
//             attr("id", "grp_cir1_rect")
//             .attr("transform", "translate(" + (nodeRadius + (nodeRadius * 0.1)) + ",0)")

//           )
//           .call(enter => enter.select('#grp_cir1_rect')
//             .append("rect")
//             .attr("id", "grp_rect")
//             .attr("x", "0")
//             .attr("y", -nodeRadius)
//             .attr("width", nodeRadius * 1)
//             .attr("height", nodeRadius * 2)
//             .style("visibility", "hidden")
//             .style("fill", "none")
//           )
//           .call(enter => enter.select('#grp_cir1_rect')
//             .append("circle")
//             .attr("r", "15")
//             .attr("x", "15")
//             .attr("y", -nodeRadius)
//             .style("visibility", "hidden")
//             .classed("cir_anchor", true)
//             .classed("circle", true)
//             .on("click", (event, d) => { return this.openRelations(d) })
//           )
//           .call(enter => enter.select('#grp_cir1_rect')
//             .append("text")
//             .text("+")
//             .attr("id", d => `cir_anchor_${d.data.id}`)
//             .classed("text", true)
//             .style("cursor", "pointer")
//             .style("font-size", "16px")
//             .style("dominant-baseline", "middle")
//             .style("visibility", "hidden")
//             .attr("pointer-events", "none")
//           )
//           .call(enter => enter.append("circle")
//             .classed('circle', true)
//             .classed('inner-circle', true)
//             .attr("id", d => `inner_cat_${d.data.id}`)
//             // .attr('r', nodeRadius)
//           )
//           .call(enter => enter.append("circle")
//             .classed('circle', true)
//             .classed('outer-circle', true)
//             .attr("id", d => `cat_${d.data.id}`)
//             // .attr('r', nodeRadius + (nodeRadius*0.1))
//             .style("visibility", "hidden")
//             .on("contextmenu", (event, d) => { return this.contextMenu(event, d) })
//             .on("click", (event, d) => { return this.nodeClicked(d, 0) })

//             // 
//           )
//           .call(enter => enter.append("text")
//             .text(d => d.data.count + ' ' + d.data.node)
//             .classed("label", true)
//             .attr("x", 0)
//             .attr("y", 0)
//             .attr("text-anchor", "middle")
//           )
//           .call(enter => enter.append("text")
//             // .text("(" + (Math.floor(Math.random() * (69690 - 1048) + 1048)) + ")")
//             .text(d => "(" + d.data.total_alert_count + " Alerts)")
//             // .text(d => "(" + getTotalCount(d) + ")")
//             // .text(d => d.data.count)

//             .classed("label-count", true)
//             .attr("x", 0)
//             .attr("y", 0)
//             .attr("text-anchor", "middle")
//           )

//           .call(enter => enter.append("text")
//             .text(d => d.data.count)
//             .classed("count", true)
//             .attr("x", 0)
//             .attr("y", 0)
//             .attr("text-anchor", "middle")
//           )
//           .call(enter => enter.append("g")
//             .classed('bubbles', true))
//         ,
//         update => update
//           .transition().duration(100)
//           .attr('transform', d => `translate(${d.y},${d.x})`)
//         ,
//         exit => exit
//           .transition().duration(100)
//           .style("opacity", 0)
//           .remove()
//       );
//     nodes.each(function (d) {
//       const packWidth = d3.select(this).node().getBBox().width;
//       const packHeight = d3.select(this).node().getBBox().height;
//       var Tooltip = d3.select(".connector")
//       .append("div")
//       .style("opacity", 1)
//       .attr("class", "tooltip")
//       .style("background-color", "white")
//       .style("border", "solid")
//       .style("border-width", "2px")
//       .style("border-radius", "5px")
//       .style("padding", "5px")
//       // if (d.data.bubbles.length) {
//       const packedRoot = d3.hierarchy({ children: d.data.bubbles }).sort((a, b) => b.count - a.count);
//       var pack = d3.pack().size([packWidth, packHeight]).radius(() => { return 5 }).padding(2);
//       pack(packedRoot);
//       // Select the .bubbles group (created in the enter phase) and bind data to circles
//       const packGroup = d3.select(this).select(".bubbles").attr("transform", `translate(${-(packWidth / 2)}, ${-(packHeight / 2)})`);
//       var nodeRadius = 0
//       if (packedRoot.r + 5 < 25)
//         nodeRadius = 25
//       else
//         nodeRadius = packedRoot.r + 5;
//       d3.select(this).select("#grp_cir1_rect").select("#grp_rect").attr("y", -nodeRadius).attr("width", nodeRadius * 1).attr("height", nodeRadius * 2);
//       d3.select(this).select('#grp_cir1_rect').attr("transform", "translate(" + (nodeRadius + (nodeRadius * 0.1)) + ",0)")
//       d3.select(this).select("#inner_cat_" + d.data.id).attr("r", nodeRadius)
//       d3.select(this).select("#cat_" + d.data.id).attr("r", nodeRadius + (nodeRadius * 0.1))
//       d3.select(this).select(".count").style("visibility", "hidden")
//       d3.select(this).select(".label").text(d => d.data.count + ' ' + d.data.node).attr("y", nodeRadius + 20)
//       d3.select(this).select(".label-count").attr("y", nodeRadius + 35).text(d => "(" + d.data.total_alert_count + " Alerts)")

//       packGroup.selectAll("circle")
//         .data(packedRoot)
//         .join(
//           enter => enter.append("circle")
//             .attr("r", 0)  // Start with radius 0 for smooth animation
//             .attr("data-id", d => d.data.id)
//             .on("mouseover", function () {
//               // d3.select(this).classed("bubble", false)
//               Tooltip.style("opacity", 1)
//               d3.select(this).classed("circle-hovered", true)
//               highlightBubbles(d, this)
//               console.log("mouseover=========================",d)
//             })
//             .on("mousemove",function(){
//               Tooltip
//               .html("The exact value of<br>this cell is: 1")
//               // .style("left", (d3.mouse(this)[0]+70) + "px")
//               // .style("top", (d3.mouse(this)[1]) + "px")
//             })
//             .on("mouseout", function () {
//               Tooltip.style("opacity", 0)
//               d3.select(this).classed("circle-hovered", false)
//               // d3.select(this).classed("bubble", true)
//               dehighlightBubbles(d, this)
//             })
//             .on("click", function () {
//               // d3.select(this).classed("bubble", false)
//               // d3.select(this).classed("circle-clicked", true)
//               highlightBubblesClicked(d, this)

//             })
//             .attr("cx", d => d.x)
//             .attr("cy", d => d.y)
//             // .attr("class", d => d.depth === 0 ? "parent-bubble" : "bubble")
//             .attr("class", d => bubbleColor(d))
//             // .attr("class", d => d.data.count == 0 && d.depth > 0 ? "empty-bubble" : "bubble")
//             // .transition().duration(100)
//             .attr("r", d => d.r)  // Animate the radius to its actual size
//           ,
//           update => update
//             // .transition().duration(100)
//             .attr("cx", d => d.x)
//             .attr("cy", d => d.y)
//             .attr("r", d => d.r)
//             .attr("class", d => bubbleColor(d)),  // Animate position and radius changes
//           exit => exit
//             // .transition().duration(100)
//             .attr("r", 0)  // Shrink radius to 0 on exit
//             .remove()  // Remove after transition
//         );
//       // }
//       // else {
//       if (!d.data.bubbles.length) {
//         // .attr("transform", `translate(${-(packWidth / 2)}, ${-(packHeight / 2)})`)
//         // .append("text").text(d.data.count)
//         // .attr("x", 0)
//         // .attr("y", 0)
//         // .attr("text-anchor", "middle")
//         var nodeRadius = 50;
//         d3.select(this).select("#grp_cir1_rect").select("#grp_rect").attr("y", -nodeRadius).attr("width", nodeRadius * 1).attr("height", nodeRadius * 2);
//         d3.select(this).select('#grp_cir1_rect').attr("transform", "translate(" + (nodeRadius + (nodeRadius * 0.1)) + ",0)")
//         d3.select(this).select("#inner_cat_" + d.data.id).attr("r", nodeRadius)
//         d3.select(this).select("#cat_" + d.data.id).attr("r", nodeRadius + (nodeRadius * 0.1))
//         d3.select(this).select(".label").text(d => d.data.count + ' ' + d.data.node).attr("y", nodeRadius + 20)
//         d3.select(this).select(".count").style("visibility", "visible").text(d => d.data.count)

//         d3.select(this).select(".label-count").attr("y", nodeRadius + 35).text(d => "(" + d.data.total_alert_count + " Alerts)")
//         d3.select(this).select(".inner-circle").attr("r", nodeRadius)
//         d3.select(this).select(".outer-circle").attr("r", nodeRadius + (nodeRadius * 0.1))
//       }
//     });

//     var links = svg.select('g.links')
//       .selectAll(".grp_path")
//       .data(root.links(), d => d.source.data.id + "-" + d.target.data.id)
//       .join(
//         enter => enter.append("g")
//           .classed("grp_path", true)
//           .call(enter => enter.append("path")
//             .attr("d", d => drawPath(d)))
//           .call(enter => enter.append("text")
//             .text(d => d.target.data.relation)
//             .classed("text", true)
//             .attr("text-anchor", "middle")
//             .attr("dominant-baseline", "middle")
//             // .attr("transform", d => `translate(${movePathLabel(d).x},${movePathLabel(d).y})`)
//             .attr("x", d => `${movePathLabel(d).x}`)
//             .attr("y", d => `${movePathLabel(d).y}`)
//             // .attr("transform", d => rotatePathText(d))
//           )
//         ,
//         update => {
//           update
//             .select("path")
//             .transition().duration(100)
//             .attr("d", d => drawPath(d))
//           // .call(update => 
//           update
//             .select("text")
//             .transition().duration(100)
//             .attr("x", d => `${movePathLabel(d).x}`)
//             .attr("y", d => `${movePathLabel(d).y}`)
//           // .attr("transform", d => rotatePathText(d))

//           // )
//         }
//         ,
//         exit => exit.remove()
//       );
//     function bubbleColor(d) {
//       if (d.depth === 0) {
//         return "parent-bubble"
//       }
//       else {
//         if (d.data.count == 0) {
//           return "empty-bubble"
//         }
//         else {
//           return "bubble"
//         }
//       }
//     }
//     function rotatePathText(d) {
//       // Calculate the angle of rotation based on source and target
//       const dx = d.target.y - d.source.y;
//       const dy = d.target.x - d.source.x;
//       const angle = Math.atan2(dy, dx) * 180 / Math.PI;  // Convert to degrees

//       // Rotate the text around its midpoint
//       return `rotate(${angle}, ${(d.source.y + d.target.y) / 2}, ${(d.source.x + d.target.x) / 2})`;
//     }
//     function movePathLabel(node) {
//       const svg = d3.select("svg");
//       var sourceNode = svg.select("#exploration-graph").select(".nodes").selectAll(".exploration-node").filter((data, i, nodes) => nodes[i].getAttribute("data-id") && nodes[i].getAttribute("data-id") == node.source.data.id);
//       var targetNode = svg.select("#exploration-graph").select(".nodes").selectAll(".exploration-node").filter((data, i, nodes) => nodes[i].getAttribute("data-id") && nodes[i].getAttribute("data-id") == node.target.data.id);
//       var sourceRadius = parseInt(sourceNode.select("#cat_" + node.source.data.id).node().getAttribute("r"));
//       var targetRadius = parseInt(targetNode.select("#cat_" + node.target.data.id).node().getAttribute("r"));

//       const sourceX = node.source.y, sourceY = node.source.x - (sourceRadius);
//       const targetX = node.target.y, targetY = node.target.x - (targetRadius);



//       var controlX = (sourceX + targetX) / 2 - 6;  // Midpoint for smooth curves
//       var controlY = (sourceY + targetY) / 2;  // Midpoint for smooth curves

//       if (sourceRadius > targetRadius) {
//         controlY = controlY + (sourceRadius) - 9
//       }
//       else if (sourceRadius < targetRadius - 12) {
//         controlY = controlY + (targetRadius) - 12
//       }
//       else {
//         controlY = controlY + targetRadius
//       }


//       // controlY = controlY + (targetRadius - sourceRadius)
//       return { x: controlX, y: controlY }
//     }
//     function drawPath(d) {
//       const svg = d3.select("svg");
//       var sourceNode = svg.select("#exploration-graph").select(".nodes").selectAll(".exploration-node").filter((data, i, nodes) => nodes[i].getAttribute("data-id") && nodes[i].getAttribute("data-id") == d.source.data.id);
//       var targetNode = svg.select("#exploration-graph").select(".nodes").selectAll(".exploration-node").filter((data, i, nodes) => nodes[i].getAttribute("data-id") && nodes[i].getAttribute("data-id") == d.target.data.id);

//       var sourceRadius = parseInt(sourceNode.select("#cat_" + d.source.data.id).node().getAttribute("r"));
//       var targetRadius = parseInt(targetNode.select("#cat_" + d.target.data.id).node().getAttribute("r"));
//       const sourceX = d.source.y, sourceY = d.source.x - (sourceRadius);
//       const targetX = d.target.y, targetY = d.target.x - (targetRadius);
//       const sourceVariance = sourceRadius * 0.2
//       const targetVariance = targetRadius * 0.2
//       const controlX = (sourceX + targetX) / 2;  // Midpoint for smooth curves
//       var controlY = (sourceY + targetY) / 2;  // Midpoint for smooth curves
//       var narrowWidth = 5; // Narrower width in the middle
//       if (sourceRadius > targetRadius) {
//         controlY = controlY + (sourceRadius / 2)
//         narrowWidth = (sourceRadius * 0.2)
//       }
//       else if (sourceRadius < targetRadius) {
//         controlY = controlY + (targetRadius / 2)
//         narrowWidth = (targetRadius * 0.2)
//       }
//       else {
//         controlY = controlY + targetRadius
//         narrowWidth = (targetRadius * 0.2)
//       }
//       return `M ${sourceX},${sourceY + sourceVariance} Q ${controlX},${controlY + narrowWidth}  ${targetX + (targetRadius * 0)},${targetY + (targetRadius * 0) + targetVariance} L ${targetX + (targetRadius * 0)},${targetY + (targetRadius * 2) - targetVariance} Q ${controlX},${controlY + (narrowWidth * 2)}  ${sourceX},${sourceY + (sourceRadius * 2) - sourceVariance} Z`;
//     }

//     function highlightBubbles(d, thisElement) {
     
//       d.data.bubbles.forEach(bubble => {
        
//         if (bubble.id == thisElement.getAttribute("data-id")) {
//           bubble.predecessors.forEach(element => {
//             var predecessors = svg.select("#exploration-graph").select(".nodes").selectAll(".bubble").filter((data, i, nodes) => nodes[i].getAttribute("data-id") && nodes[i].getAttribute("data-id") == element);
//             predecessors.classed("circle-hovered-predecessors", true)
//             // Tooltip.style("opacity", 1)
//           });
//         }

//       });
//       // d.data.predecessorIds.forEach(element => {
//       //   var predecessors = d3.select("#exploration-graph").select(".nodes").selectAll(".bubble").filter((data, i, nodes) => nodes[i].getAttribute("data-id") && nodes[i].getAttribute("data-id") == element);
//       //   // predecessors.classed("bubble", false)
//       //   predecessors.classed("circle-clicked-predecessors", true)
//       // });
//       d.data.children.forEach(element => {
//         // traverse(element)
//         element.bubbles.forEach(bubble => {
//           if (bubble.predecessors.includes(d3.select(thisElement).node().getAttribute("data-id"))) {
//             var predecessors = svg.select("#exploration-graph").select(".nodes").selectAll(".bubble").filter((data, i, nodes) => nodes[i].getAttribute("data-id") && nodes[i].getAttribute("data-id") == bubble.id);
//             // predecessors.classed("bubble", false)
//             predecessors.classed("circle-hovered-predecessors", true)
//           }
//         });

//       });

//       function traverse(element) {
//         element.bubbles.forEach(bubble => {
//           if (bubble.predecessors.includes(d3.select(thisElement).node().getAttribute("data-id"))) {
//             var predecessors = svg.select("#exploration-graph").select(".nodes").selectAll(".bubble").filter((data, i, nodes) => nodes[i].getAttribute("data-id") && nodes[i].getAttribute("data-id") == bubble.id);
//             // predecessors.classed("bubble", false)
//             predecessors.classed("circle-hovered-predecessors", true)
//           }
//         });
//         if (element.children && element.children.length) {
//           traverse(element)
//         }
//       }

//     }
//     function highlightBubblesClicked(d, thisElement) {
//       // d3.select("#exploration-graph").select(".nodes").selectAll(".circle-clicked").classed("circle-clicked", false).classed("bubble", true)
//       d3.select("#exploration-graph").select(".nodes").selectAll(".circle-clicked").classed("circle-clicked", false)

//       d3.select(thisElement).classed("circle-hovered", false)
//       // d3.select(thisElement).classed("bubble", false)
//       d3.select(thisElement).classed("circle-clicked", true)
//       // d3.select("#exploration-graph").select(".nodes").selectAll(".circle-hovered-predecessors").classed("circle-hovered-predecessors", false).classed("bubble", true)
//       // d3.select("#exploration-graph").select(".nodes").selectAll(".circle-clicked-predecessors").classed("circle-clicked-predecessors", false).classed("bubble", true)
//       d3.select("#exploration-graph").select(".nodes").selectAll(".circle-hovered-predecessors").classed("circle-hovered-predecessors", false)
//       d3.select("#exploration-graph").select(".nodes").selectAll(".circle-clicked-predecessors").classed("circle-clicked-predecessors", false)
//       d.data.bubbles.forEach(bubble => {
//         if (bubble.id == thisElement.getAttribute("data-id")) {
//           bubble.predecessors.forEach(element => {
//             var predecessors = d3.select("#exploration-graph").select(".nodes").selectAll(".bubble").filter((data, i, nodes) => nodes[i].getAttribute("data-id") && nodes[i].getAttribute("data-id") == element);
//             predecessors.classed("circle-clicked-predecessors", true)
//           });
//         }

//       });
//       // d.data.predecessorIds.forEach(element => {
//       //   var predecessors = d3.select("#exploration-graph").select(".nodes").selectAll(".bubble").filter((data, i, nodes) => nodes[i].getAttribute("data-id") && nodes[i].getAttribute("data-id") == element);
//       //   // predecessors.classed("bubble", false)
//       //   predecessors.classed("circle-clicked-predecessors", true)
//       // });


//       d.data.children.forEach(element => {
//         element.bubbles.forEach(bubble => {
//           if (bubble.predecessors.includes(d3.select(thisElement).node().getAttribute("data-id"))) {
//             var predecessors = svg.select("#exploration-graph").select(".nodes").selectAll(".bubble").filter((data, i, nodes) => nodes[i].getAttribute("data-id") && nodes[i].getAttribute("data-id") == bubble.id);
//             // predecessors.classed("bubble", false)
//             predecessors.classed("circle-clicked-predecessors", true)
//           }
//         });

//       });


//     }
//     function dehighlightBubbles(d, thisElement) {
//       d.data.predecessorIds.forEach(element => {
//         var predecessors = svg.select("#exploration-graph").select(".nodes").selectAll(".circle-hovered-predecessors").filter((data, i, nodes) => nodes[i].getAttribute("data-id") && nodes[i].getAttribute("data-id") == element);

//         predecessors.classed("circle-hovered-predecessors", false)
//         // predecessors.classed("bubble", true)

//       });

//       d.data.children.forEach(element => {
//         element.bubbles.forEach(bubble => {
//           if (bubble.predecessors.includes(d3.select(thisElement).node().getAttribute("data-id"))) {
//             var predecessors = svg.select("#exploration-graph").select(".nodes").selectAll(".circle-hovered-predecessors").filter((data, i, nodes) => nodes[i].getAttribute("data-id") && nodes[i].getAttribute("data-id") == bubble.id);
//             predecessors.classed("circle-hovered-predecessors", false)
//             // predecessors.classed("bubble", true)
//           }
//         });
//       });
//     }
//     function getTotalCount(d) {
//       var count = 0;
//       d.data.bubbles.forEach(element => {
//         count = count + element.count
//       });
//       return count
//     }
//   }



//   contextMenu(event, node) {
//     event.preventDefault();
//     this.relationist = node.data
//     let origin = document.getElementById("cat_" + node.data.id)
//     let config = {
//       data: {
//         "template": this.contextList,
//       }
//     };
//     this.contextListMenu = this.cdkoverlayDialog.openMenu(config, TemplateDropdownComponent, origin);
//   }
//   genRamdomNumber(d) {
//     var count = d.data.count
//     var childCount = 0
//     d.data.bubbles.forEach(element => {
//       childCount = childCount + element.count
//     });
//     if (childCount) {
//       return childCount
//     } else {
//       return count
//     }

//   }

//   checkMutualExclusive_Addfilter() {
//     this.alertvarService.filters.forEach((obj) => {
//       if (this.alertvarService.mutual_exclusive_filters.hasOwnProperty(obj.category)) {
//         if (this.alertvarService.mutual_exclusive_filters[obj.category].hasOwnProperty(obj.label)) {
//           this.alertvarService.mutual_exclusive_filters[obj.category][obj.label].isSelected = obj.isSelected
//         }
//       }
//     })
//   }


//   categories_filters() {
//     this.alertvarService.selectedInstantFilter = JSON.parse(JSON.stringify(this.alertvarService.instantfilters[this.alertvarService.lastClickedNode.relation]))
//     // this.alertvarService.filters = this.alertvarService.nodeinfo.instantFilter
//     this.alertvarService.filters = [...this.alertvarService.nodeinfo.instantFilterDisplay]
//     // this.alertvarService.applied_filters = this.alertvarService.nodeinfo.instantFilterDisplay
//     this.alertvarService.mutual_exclusive_filters = JSON.parse(JSON.stringify(this.alertvarService.mutual_exclusive_filters_template))
//     this.checkMutualExclusive_Addfilter()
//     for (let filtername in this.alertvarService.selectedInstantFilter) {
//       this.alertvarService.filterpannelexpanded[filtername] = true;
//       this.alertvarService.selectedInstantFilter[filtername].forEach((element, index) => {
//         var result = this.alertvarService.filters.findIndex((obj) => { return obj.label == element.label && obj.category == element.category })
//         if (result >= 0) {
//           this.alertvarService.selectedInstantFilter[filtername][index].isSelected = true;
//         }
//       })
//     };

//     this.alertvarService.limitfilter_list = this.alertvarService.selectedInstantFilter.hasOwnProperty('limit') ? this.alertvarService.selectedInstantFilter['limit'].map(item => item.label) : [];
//     // console.log(this.alertvarService.limitfilter_list)
//     let limitstring = this.alertvarService.selectedInstantFilter.hasOwnProperty('limit') ? this.alertvarService.selectedInstantFilter['limit'].filter(item => item.isSelected == true).map(item => item.label)[0] : ""
//     if (limitstring != undefined) {
//       this.alertvarService.limitfilter.setValue(limitstring);
//     } else {
//       this.alertvarService.limitfilter.setValue('Show all');
//     }

//     this.alertvarService.filterslist = this.alertvarService.filters.filter((obj) => obj.category != 'limit')
//   }

//   nodeClicked(node, selector) {
//     if (!this.isAction) {
//       d3.select("#exploration-graph").select(".nodes").selectAll(".outer-circle-selected").classed("outer-circle-selected", false).classed("outer-circle", true)
//       d3.select("#exploration-graph").select(".nodes").selectAll(".inner-circle-selected").classed("inner-circle-selected", false).classed("inner-circle", true)
//       var selectedOuterCircle = d3.select("#exploration-graph").select(".nodes").select("#cat_" + node.data.id)
//       var selectedInnerCircle = d3.select("#exploration-graph").select(".nodes").select("#inner_cat_" + node.data.id)
//       selectedInnerCircle.classed("inner-circle", false)
//       selectedInnerCircle.classed("inner-circle-selected", true)
//       selectedOuterCircle.classed("outer-circle", false)
//       selectedOuterCircle.classed("outer-circle-selected", true)
//       this.alertvarService.lastClickedNode = node.data;
//       // if (!(node.data.node == "other_series" || node.data.node == "fields"))
//       this.NodeSelected.emit([selector, this.alertvarService.lastClickedNode])
//       this.alertvarService.nodeSelected = true
//       // this.alertvarService.selectedInstantFilter = {}
//       // this.alertvarService.selectedInstantFilter = JSON.parse(JSON.stringify(this.alertvarService.instantfilters[this.alertvarService.lastClickedNode.relation]))
//       // this.alertvarService.filters = this.alertvarService.nodeinfo.instantFilter
//       // this.alertvarService.selectedInstantFilter.forEach((element, index) => {
//       //   var result = this.alertvarService.filters.findIndex((obj) => { return obj.label == element.label })
//       //   if (result >= 0) {
//       //     this.alertvarService.selectedInstantFilter[index].isSelected = true
//       //   }
//       // });
//       // console.log("selectedInstantFilter",this.alertvarService.selectedInstantFilter)

//       this.categories_filters()
//     }
//   }

//   openRelations(node) {
//     // this.getRelations(node)
//     // this.alertService.selectedNode = node;
//     // if (!this.inProgress) {
//     if (!(node.data.node == "other_series")) {
//       this.relationist = node.data

//       let origin = document.getElementById("cir_anchor_" + node.data.id)
//       let config = {
//         data: {
//           "template": this.relationList,
//         }
//       };
//       this.relationListMenu = this.cdkoverlayDialog.openMenu(config, TemplateDropdownComponent, origin);
//     }
//   }

//   openInstantfilterOverlay(parentid:string,childid:string,relation:any){
//     this.closeInstantfilterOverlay()
//     this.instantFilterOption = relation
//     let origin = document.getElementById("filter-"+parentid.toString()+'-'+childid.toString())
//     console.log('openInstantfilterOverlay=========>',origin,this.instantfilter)
//       let config = {
//         data: {
//           "template": this.instantfilter,
//         },
//         hasBackdrop:false
//       };
//       this.instantfilterMenu = this.cdkoverlayDialog.openMenu(config, TemplateDropdownComponent, origin);
//   }

//   closeInstantfilterOverlay(){
//     if(this.instantfilterMenu){
//       this.instantfilterMenu.close()
//     }
//   }
//   addNode(relation, childName, instantFilter, node) {
//     var currentNode = this.getObjectById(this.alertvarService.chartData, node.id)
//     // var parentNode = this.getParentById(this.alertvarService.chartData, currentNode.id)
//     var lastChildId;
//     var branches
//     if (currentNode.children.length) {
//       lastChildId = currentNode.children[currentNode.children.length - 1].id
//       branches = lastChildId.split("_")
//       branches[branches.length - 1] = parseInt(branches[branches.length - 1]) + 1
//     }
//     else {
//       lastChildId = currentNode.id
//       branches = lastChildId.split("_")
//       branches.push("1")
//     }
//     var predecessors = []
//     // currentNode.bubbles.forEach(element => {
//     //   predecessors.push(element.id)
//     // });
//     var newChild = {
//       "id": branches.join("_"),
//       "node": childName.label.toLowerCase(),
//       "count": 0,
//       "bubbles": [],
//       "filters": [],
//       "children": [],
//       "predecessorIds": [],
//       "relation": relation.label,
//       "instantFilter": [instantFilter],
//       "instantFilterDisplay": [instantFilter]
//     }
//     currentNode.children.push(newChild)
//     this.alertvarService.handleprovided3chartdataerror.resetError();
//     // this.updateKeyInAllObjects(currentNode, "bubbles", [])
//     var parentNode = this.getParentById(currentNode, newChild.id)

//     var req_obj = {
//       "alert_id": this.alertvarService.alertscollapsedata.selectedalert.alertId,

//       "season_time": [this.timezoneservice.toUtcTimeZonefromUser(this.alertvarService.advanced_filter_values.start_time).format("YYYY-MM-DD HH:mm:ss"), this.alertvarService.advanced_filter_values.end_time],
//       "episode_duration": this.alertvarService.advanced_filter_values.time_interval.value,
//       "threshold": this.alertvarService.bubbleThreshold,
//       "parent_node": parentNode ? parentNode.node : "",
//       // "template": currentNode,
//       "template": newChild,

//       "filters": this.alertvarService.getBubbleValues(currentNode),
//       "relation": currentNode.relation,
//       // "new_node": branches.join("_")
//     }
//     this.alertService.provided3chartevents.postrequest(req_obj)

//       .pipe(takeUntil(this.$destroy))
//       .subscribe((data: any) => {
//         // this.updateObjectById(this.alertvarService.chartData, currentNode.id, data)
//         this.updateObjectById(this.alertvarService.chartData, data.id, data)

//         setTimeout(() => {
//           this.updateChart()
//         }, 500);
//       },
//         (error) => {
//           this.deleteObjectById(this.alertvarService.chartData, branches.join("_"))
//           this.alertvarService.handleprovided3chartdataerror.seterror(true, error.error?.errmsg)
//         })

//     this.relationListMenu.close()
//     // this.instantfilterMenu.close()
//     // this.alertvarService.chartData.children.push({'bubbles': [], 'count': 229, 'predecessorIds': [], 'id': '1_1', 'node': 'episodes', 'children': [], 'relation': 'relation', 'relationsList': [{'label': 'emitedby', 'direction': 'outgoing', 'relations': [{'label': 'source', 'direction': '', 'relations': []}, {'label': 'fields', 'direction': '', 'relations': []}]}, {'label': 'hasemited', 'direction': 'outgoing', 'relations': [{'label': 'episodes', 'direction': '', 'relations': []}]}, {'label': 'hasemited', 'direction': 'outgoing', 'relations': [{'label': 'episodes', 'direction': '', 'relations': []}, {'label': 'source', 'direction': '', 'relations': []}, {'label': 'series', 'direction': '', 'relations': []}]}]})
//     // this.updateChart()

//   }
//   RemoveNode(node) {
//     this.contextListMenu.close()
//     // this.alertvarService.chartData.children.pop()
//     this.deleteObjectById(this.alertvarService.chartData, node.id)
//     this.updateChart()

//   }
//   updateNode() {
//     var newData = { 'bubbles': [], 'count': 229, 'predecessorIds': [], 'id': '1_1', 'node': 'episodes', 'children': [], 'relation': 'relation', 'relationsList': [{ 'label': 'emitedby', 'direction': 'outgoing', 'relations': [{ 'label': 'source', 'direction': '', 'relations': [] }, { 'label': 'fields', 'direction': '', 'relations': [] }] }, { 'label': 'hasemited', 'direction': 'outgoing', 'relations': [{ 'label': 'episodes', 'direction': '', 'relations': [] }] }, { 'label': 'hasemited', 'direction': 'outgoing', 'relations': [{ 'label': 'episodes', 'direction': '', 'relations': [] }, { 'label': 'source', 'direction': '', 'relations': [] }, { 'label': 'series', 'direction': '', 'relations': [] }] }] }
//     this.updateObjectById(this.alertvarService.chartData, "1_2", newData)
//     this.updateChart()
//   }

//   // centerAlign() {
//   //   const svg = d3.select(".connector").node().getBBox();
//   //   const svgWidth = svg.width;
//   //   const svgHeight = svg.height;

//   //   const bbox = d3.select("#exploration-graph").node().getBBox();
//   //   const graphWidth = bbox.width;
//   //   const graphHeight = bbox.height;

//   //   // Calculate the position to center the graph
//   //   const centerX = (svgWidth / 2) - (graphWidth / 2);
//   //   // const centerY = (svgHeight / 2) - (graphHeight / 2);
//   //   const centerY = (svgHeight / 2);
//   //   // Apply the translation
//   //   d3.select("#exploration-graph").attr("transform", `translate(${centerX}, ${centerY})`);
//   // }
//   listhovered(index) {
//     // const element = this.hoverElements.toArray()[index].nativeElement;
//     // const style = element.getBoundingClientRect();

//   }
//   getObjectById(obj, id) {
//     if (obj.id === id) return obj; // Base case: found the object

//     if (obj.children && obj.children.length > 0) {
//       for (const child of obj.children) {
//         const result = this.getObjectById(child, id);
//         if (result) return result; // If found in any child, return it
//       }
//     }
//     return null; // If not found
//   }
//   getParentById(obj, childId) {
//     if (obj.id === childId) return null; // Base case: found the object

//     // If the current object has children, check each child
//     if (obj.children && obj.children.length > 0) {
//       for (const child of obj.children) {
//         if (child.id === childId) {
//           return obj; // Return current object as it is the parent
//         }

//         // Recursively search in children
//         const result = this.getParentById(child, childId);
//         if (result) return result; // If found in deeper levels, return the parent
//       }
//     }
//     return null; // If no parent is found
//   }
//   updateObjectById(obj, id, newData) {
//     const objectToUpdate = this.getObjectById(obj, id);
//     if (objectToUpdate) {
//       Object.assign(objectToUpdate, newData); // Merge newData into the found object
//     } else {
//       console.log("Object not found");
//     }
//   }
//   deleteObjectById(obj, id) {
//     if (obj.children && obj.children.length > 0) {
//       obj.children = obj.children.filter(child => child.id !== id); // Remove the child with the matching id
//       for (const child of obj.children) {
//         this.deleteObjectById(child, id); // Recursively check for nested children
//       }
//     }
//   }
//   addChildObject(obj, parentId, newChild) {
//     const parentNode = this.getObjectById(obj, parentId); // Reuse getObjectById function
//     if (parentNode) {
//       // Check if the parent node has a children array, if not, initialize it
//       if (!parentNode.children) {
//         parentNode.children = [];
//       }
//       parentNode.children.push(newChild); // Add the new child to the parent's children
//     } else {
//       console.log("Parent node not found");
//     }
//   }
//   updateKeyInAllObjects(obj, key, newValue) {
//     console.log(obj)
//     // Check if the current object has the key, and update it
//     if (obj.hasOwnProperty(key)) {
//       obj[key] = newValue;
//     }

//     // If the object has children, recursively update the key in them
//     if (obj.children && obj.children.length > 0) {
//       for (const child of obj.children) {
//         this.updateKeyInAllObjects(child, key, newValue);
//       }
//     }
//   }
//   updateKeyInNestedObjects(obj, key, newValue) {
//     // Create a deep copy of the object to avoid modifying the original
//     const newObj = structuredClone(obj);

//     // Helper function to update the key in a cloned object
//     function updateKeyRecursively(obj) {
//       // Update the key if it exists in the current object
//       if (obj.hasOwnProperty(key)) {
//         obj[key] = newValue;
//       }

//       // Recursively update the key in children, if they exist
//       if (obj.children && obj.children.length > 0) {
//         for (const child of obj.children) {
//           updateKeyRecursively(child);
//         }
//       }
//     }

//     updateKeyRecursively(newObj); // Update the cloned object
//     return newObj; // Return the modified clone
//   }


//   openOverlay_moreoptions_click(template, origin): void {
//     // this.moreOptionState = true
//     // let config = {
//     //   data: {
//     //     "template": template,
//     //   }
//     // }
//     // this.dialogRef = this.cdkoverlayDialog.openMenu(config, TemplateDropdownComponent, origin);
//     this.moreOptionState = !this.moreOptionState
//   }
//   closeOptions_click() {
//     if (this.dialogRef) {
//       this.dialogRef.close()
//       this.moreOptionState = false
//     }
//   }
//   changeTemplate(template) {
//     this.templateRef.close()
//     this.closeOptions_click()
//     console.log("changeTemplate====>", template)
//     this.alertvarService.chartData = template.temp
//     var req_obj = {
//       "alert_id": this.alertvarService.alertscollapsedata.selectedalert.alertId,

//       "season_time": [this.timezoneservice.toUtcTimeZonefromUser(this.alertvarService.advanced_filter_values.start_time).format("YYYY-MM-DD HH:mm:ss"), this.alertvarService.advanced_filter_values.end_time],
//       "episode_duration": this.alertvarService.advanced_filter_values.time_interval.value,
//       "threshold": this.alertvarService.bubbleThreshold,
//       "parent_node": "",
//       "template": template.temp,
//       // "filters": [],
//       "relation": template.temp.relation,
//       "new_node": ""

//       // "token": "74e6ec28",
//       // "request_type": "process"


//     }
//     this.alertService.updated3chartevents.postrequest(req_obj)
//       .pipe(takeUntil(this.$destroy))
//       .subscribe((data: any) => {
//         this.updateObjectById(this.alertvarService.chartData, data.id, data)
//         setTimeout(() => {
//           this.updateChart()
//           this.nodeClicked({ "data": this.alertvarService.chartData }, 1)
//         }, 500);
//       }, (error) => {
//         this.alertvarService.handleprovided3chartdataerror.seterror(true, error.error?.errmsg)
//       })
//   }
//   openOverlay_templates(template, origin) {
//     if (!this.isAction) {
//       let config = {
//         data: {
//           "template": template,
//         }
//       }
//       this.templateRef = this.cdkoverlayDialog.openMenu(config, TemplateDropdownComponent, origin);
//     }
//   }
//   openOverlay_preview(template, origin) {
//     let config = {
//       data: {
//         "template": template,
//       }
//     }
//     this.visualizeRef = this.cdkoverlayDialog.openMenu(config, TemplateDropdownComponent, origin);
//     setTimeout(() => {
//       var Nodedata = this.getNodeChartData()
//       this.myChart = echarts.init(document.getElementById("nodeChart"));
//       this.myChart.setOption({
//         xAxis: {
//           data: Nodedata.axisData
//         },
//         series: {
//           data: Nodedata.seriesData
//         }
//       })
//     }, 200);
//   }
//   clearSvg() {
//     if (!this.isAction) {
//       d3.select(".connector").selectAll("#exploration-graph").select(".links").selectAll("*").remove()
//       d3.select(".connector").selectAll("#exploration-graph").select(".nodes").selectAll("*").remove()
//       this.alertvarService.chartData = {}
//       this.alertvarService.load_default_chartdata();
//     }
//   }

//   reset() {
//     // var temp = this.getObjectById(this.alertvarService.chartData, this.alertvarService.chartData.id)
//     var temp = JSON.parse(JSON.stringify(this.alertvarService.templates[1].temp))
//     this.alertvarService.nodeinfo = temp
//     this.alertvarService.nodeinfo.children = []
//     this.alertvarService.nodeinfo.filters = []
//     var tempStructure = this.updateKeyInNestedObjects(this.alertvarService.nodeinfo, "bubbles", [])
//     tempStructure = this.updateKeyInNestedObjects(tempStructure, "bubble_values", [])
//     tempStructure = this.updateKeyInNestedObjects(tempStructure, "predecessorIds", [])
//     tempStructure = this.updateKeyInNestedObjects(tempStructure, "target_entity", [])


//     var req_obj = {
//       "alert_id": this.alertvarService.alertscollapsedata.selectedalert.alertId,

//       "season_time": [this.timezoneservice.toUtcTimeZonefromUser(this.alertvarService.advanced_filter_values.start_time).format("YYYY-MM-DD HH:mm:ss"), this.alertvarService.advanced_filter_values.end_time],
//       "episode_duration": this.alertvarService.advanced_filter_values.time_interval.value,
//       "threshold": this.alertvarService.bubbleThreshold,
//       "parent_node": "",
//       "template": tempStructure,
//       // "filters": [],
//       "relation": tempStructure.relation,
//       "new_node": ""

//       // "token": "74e6ec28",
//       // "request_type": "process"


//     }
//     this.alertService.updated3chartevents.postrequest(req_obj)
//       .pipe(takeUntil(this.$destroy))
//       .subscribe((data: any) => {
//         this.updateObjectById(this.alertvarService.chartData, data.id, data)
//         setTimeout(() => {
//           this.updateChart()
//           this.nodeClicked({ "data": this.alertvarService.chartData }, 1)
//         }, 500);
//       }, (error) => {
//         this.alertvarService.handleprovided3chartdataerror.seterror(true, error.error?.errmsg)
//       })
//   }

//   getNodeChartData() {
//     var axisData = []
//     var seriesData = []
//     if (this.alertvarService.lastClickedNode) {

//       if (this.alertvarService.lastClickedNode.node == "episodes") {
//         this.alertvarService.lastClickedNode.bubbles.forEach(element => {
//           var d = this.timezoneservice.toUserTimeZone(parseInt(element.value)).format("MMM DD HH:mm")
//           axisData.push(d)
//           seriesData.push(element.count)
//         });

//       }
//       else {
//         this.alertvarService.lastClickedNode.bubbles.forEach(element => {
//           seriesData.push(element.count)
//           axisData.push(element.value)
//         });
//       }


//     }
//     return { "axisData": axisData, "seriesData": seriesData }
//   }
//   openPreview() {
//     // this.openOverlay_moreoptions_click(this.moreOptionRef, this.moreOptionOrigin)
//     setTimeout(() => {
//       this.openOverlay_preview(this.visualizeRefTemp, this.visualizeOptionOrigin)

//     }, 500);
//   }
//   showLegend() {
//     this.alertvarService.legendState = !this.alertvarService.legendState
//   }
//   cancel_relationChart() {
//     this.alertvarService.handleDetaildataerror.seterror(true, this.alertvarService.alertsheetmeta.noDatamsg[2]);
//     this.alertService.provided3chartevents.cancelRequest();
//   }







//   // poc parent,child overlay munipulate

//   // overlayRefs: Map<string, OverlayRef> = new Map();
//   // activeMenu: any | null = null;
//   // closeMenu(menuId) {
//   //   const overlayRef = this.overlayRefs.get(menuId);
//   //   if (overlayRef) {
//   //     overlayRef.detach();
//   //     overlayRef.dispose();
//   //     this.overlayRefs.delete(menuId);
//   //   }
//   //   if (this.activeMenu === menuId) {
//   //     this.activeMenu = null;
//   //   }
//   // }


//   // toggleMenu(event: MouseEvent, menuId:string,relation:any){
//   //   console.log(menuId,relation)
//   //   this.instantFilterOption = relation
//   //   if (this.activeMenu === menuId) {
//   //     this.closeMenu(menuId);
//   //     return;
//   //   }

//   //   this.closeAllMenus(); // Close other open menus

//   //   const overlayRef = this.createOverlay(event);
//   //   // console.log(this.relationList)
//   //   // const templateRef = this.relationList.find(template) => {
//   //   //   console.log()
//   //   // });
//   //   // if (!templateRef) {
//   //   //   console.error('TemplateRef not found for menuId:', menuId);
//   //   //   return;
//   //   // }
//   //   const templatePortal = new TemplatePortal(
//   //     this.instantfilter,
//   //     this.viewContainerRef
//   //   );
//   //   console.log(templatePortal)
//   //   overlayRef.attach(templatePortal);
//   //   this.overlayRefs.set(menuId, overlayRef);
//   //   this.activeMenu = menuId;


//   // }
//   // private createOverlay(event: MouseEvent): OverlayRef {
//   //     return this.overlay.create({
//   //       positionStrategy: this.overlay.position()
//   //         .flexibleConnectedTo({ x: event.clientX, y: event.clientY })
//   //         .withPositions([
//   //           {
//   //             originX: 'start',
//   //             originY: 'bottom',
//   //             overlayX: 'start',
//   //             overlayY: 'top',
//   //           },
//   //         ]),
//   //       hasBackdrop: false,
//   //       scrollStrategy: this.overlay.scrollStrategies.reposition(),
//   //     });
//   //   }
//   //   closeAllMenus() {
//   //     this.overlayRefs.forEach((ref, key) => {
//   //       this.closeMenu(key);
//   //     });
//   //   }

// }
